{
  "common": {
    "main": {
      "project": "Projeto",
      "form": "Formulário",
      "version": "Versão",
      "formSettings": "Configuração de formulário",
      "user": "Usuário",
      "organization": "Organização",
      "server": "Servidor",
      "url": "URL"
    },
    "buttons": {
      "ok": "OK",
      "cancel": "Cancelar",
      "save": "Salvar",
      "add": "Adicionar",
      "edit": "Editar",
      "delete": "Excluir",
      "refresh": "Atualizar",
      "create": "Criar",
      "submit": "Enviar",
      "clear": "Limpar",
      "selectAll": "Selecionar tudo",
      "back": "Voltar",
      "next": "Próximo",
      "previous": "Anterior",
      "close": "Fechar",
      "confirm": "Confirmar",
      "yes": "Sim",
      "no": "Não",
      "search": "Pesquisar",
      "filter": "Filtrar",
      "export": "Exportar",
      "import": "Importar",
      "download": "Baixar",
      "upload": "Carregar",
      "view": "Visualizar",
      "preview": "Pré-visualizar",
      "copy": "Copiar",
      "assign": "Atribuir",
      "unassign": "Desvincular",
      "retry": "Tentar novamente",
      "loading": "Carregando..."
    },
    "dialogs": {
      "cancel": "Cancelar",
      "close": "Fechar",
      "confirm": "Confirmar",
      "delete": "Excluir",
      "save": "Salvar alterações",
      "confirmTitle": "Confirmar ação",
      "unsavedChanges": {
        "title": "Alterações não salvas",
        "message": "Há alterações não salvas. Fechar sem salvar?"
      }
    },
    "table": {
      "headers": {
        "name": "Nome",
        "description": "Descrição",
        "statistics": "Estatísticas",
        "status": "Estado",
        "actions": "Ações",
        "createdAt": "Data de criação",
        "updatedAt": "Data de atualização",
        "created": "Criado",
        "updated": "Atualizado",
        "type": "Tipo",
        "version": "Versão",
        "id": "ID",
        "email": "Email",
        "role": "Função",
        "user": "Usuário",
        "project": "Projeto",
        "organization": "Organização",
        "lastSubmission": "Última submissão",
        "server": "Servidor",
        "url": "URL",
        "format": "Formato",
        "count": "Contagem",
        "size": "Tamanho",
        "date": "Data",
        "time": "Hora",
        "severity": "Severidade",
        "field": "Campo Principal",
        "form": "Formulário",
        "state": "Estado",
        "roles": "Funções",
        "groups": "Grupos",
        "formId": "ID do formulário",
        "permissions": "Permissões",
        "enabled": "Habilitado",
        "disabled": "Desabilitado",
        "submissions": "Submissões",
        "publishedAt": "Publicado em"
      },
      "pagination": {
        "page": "Página",
        "of": "de",
        "perPage": "por página",
        "showing": "A mostrar",
        "to": "até",
        "totalEntries": "entradas totais",
        "resultsText": "resultados.",
        "perPageText": "Resultados por página"
      },
      "ariaLabels": {
        "viewDetails": "Ver detalhes",
        "edit": "Editar",
        "delete": "Excluir",
        "previousPage": "Página anterior",
        "nextPage": "Próxima página"
      }
    },
    "status": {
      "active": "Ativo",
      "inactive": "Inativo",
      "archived": "Arquivado",
      "draft": "Rascunho",
      "published": "Publicado",
      "pending": "Pendente",
      "completed": "Concluído",
      "failed": "Falhou",
      "success": "Sucesso",
      "error": "Erro",
      "warning": "Aviso",
      "info": "Informação",
      "loading": "Carregando",
      "notSet": "Não definido",
      "notSpecified": "Não especificado",
      "notAvailable": "N/A",
      "unknown": "Desconhecido",
      "enabled": "Habilitado",
      "disabled": "Desabilitado"
    },
    "messages": {
      "confirmDelete": "Tem certeza de que deseja excluir",
      "confirmDeleteWithName": "Tem certeza de que deseja excluir \"{name}\"?",
      "deleteSuccess": "Excluído com sucesso",
      "deleteError": "Erro ao excluir",
      "saveSuccess": "Salvo com sucesso",
      "saveError": "Erro ao salvar",
      "createSuccess": "Criado com sucesso",
      "createError": "Erro ao criar",
      "updateSuccess": "Atualizado com sucesso",
      "updateError": "Erro ao atualizar",
      "error": "Erro",
      "loadError": "Erro ao carregar",
      "noData": "Sem dados",
      "noResults": "Sem resultados",
      "required": "Este campo é obrigatório",
      "invalidEmail": "Por favor, insira um email válido",
      "confirmDeleteWithType": "Tem certeza de que deseja excluir \"{name}\" ({type})?",
      "bulkOperationSuccess": "Operação em massa concluída com sucesso",
      "bulkOperationError": "Erro ao executar operação em massa",
      "operationFailed": "Falha ao executar operação",
      "unsavedChanges": "O formulário contém alterações não salvas. Tem certeza de que deseja fechá-lo?",
      "created": "criado",
      "updated": "atualizado",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "Estatísticas",
      "subtitle": "Revise as métricas a nível organizacional, os estados dos formulários e a atividade dos projetos.",
      "overall": "Estatísticas Gerais",
      "byState": "Formulários por Estado",
      "projectDetails": "Detalhes do Projeto",
      "projectLedger": "Registro de projetos",
      "pipeline": "Estado",
      "projectCount": "{count} projetos",
      "noActiveForms": "Nenhum formulário ativo",
      "projects": "Projetos",
      "totalForms": "Total de Formulários",
      "activeForms": "Formulários Ativos",
      "submissions": "Submissões",
      "forms": "Formulários",
      "lastUpdated": "Última atualização",
      "noDataToDisplay": "Nenhum dado para exibir"
    },
    "viewMode": {
      "cards": "Cartões",
      "table": "Tabela",
      "list": "Lista",
      "grid": "Grade"
    },
    "time": {
      "today": "hoje",
      "yesterday": "ontem",
      "thisWeek": "esta semana",
      "lastWeek": "semana passada",
      "thisMonth": "este mês",
      "lastMonth": "mês passado",
      "allTime": "todo o tempo",
      "last7Days": "Últimos 7 dias",
      "last30Days": "Últimos 30 dias",
      "last90Days": "Últimos 90 dias",
      "customRange": "Intervalo personalizado",
      "startDate": "Data de início",
      "endDate": "Data de fim",
      "justNow": "Justo agora",
      "minutesAgo": "há {count} min",
      "hoursAgo": "há {count} h",
      "daysAgo": "há {count} dias",
      "never": "Nunca"
    },
    "placeholders": {
      "enterName": "Inserir nome",
      "enterDescription": "Inserir descrição",
      "enterEmail": "Inserir email",
      "enterUrl": "Inserir URL",
      "search": "Pesquisar...",
      "selectOption": "Selecionar opção"
    },
    "formState": {
      "title": "Alterar Estado do Formulário",
      "form": "Formulário",
      "currentStatus": "Estado atual",
      "newStatus": "Novo estado",
      "pleaseSelectStatus": "Por favor selecione um estado",
      "statusChangedSuccessfully": "Estado do formulário {formName} alterado com sucesso para {status}",
      "errorChangingStatus": "Erro ao alterar o estado do formulário"
    }
  },
  "admin": {
    "agent": {
      "title": "Agente AI",
      "subtitle": "Monitorar e gerir a integração do agente AI",
      "back": "Voltar ao painel",
      "sections": {
        "metrics": "Pulso"
      },
      "health": {
        "title": "Integração de saúde",
        "checkNow": "Verificar agora",
        "latency": "Latência",
        "lastCheck": "Última verificação"
      },
      "stats": {
        "activeSubs": "Subscrições ativas",
        "requestsToday": "Solicitações hoje",
        "tokensToday": "Tokens hoje",
        "nearQuota": "Orgs perto da quota",
        "activeSubsHint": "{total} no total",
        "nearQuotaHint": ">80% usado"
      },
      "config": {
        "title": "Configuração (somente leitura)"
      },
      "jobs": {
        "title": "Jobs RQ (relatórios analíticos)",
        "empty": "Nenhum job recente"
      },
      "digests": {
        "title": "Digests proativos",
        "trigger": "Disparar manualmente",
        "historyTitle": "Histórico de digests",
        "historyEmpty": "Nenhum digest executado ainda."
      },
      "selfHeal": {
        "title": "Jobs de auto-cura",
        "trigger": "Executar agora"
      },
      "incident": {
        "banner": "Hermes ou MCP não estão disponíveis. As funcionalidades do agente podem estar limitadas.",
        "title": "Requer atenção"
      },
      "subscriptions": {
        "title": "Subscrições do agente",
        "subtitle": "Gerir tiers, quotas e funcionalidades por organização",
        "searchPlaceholder": "Pesquisar organização...",
        "allTiers": "Todos os níveis",
        "editTitle": "Editar subscrição",
        "resetTitle": "Repor uso",
        "resetMessage": "Repor contadores de uso para {name}?",
        "resetConfirm": "Repor",
        "empty": "Nenhuma subscrição encontrada",
        "tierDefaultsTitle": "Níveles predefinidos",
        "tierDefaultsHint": "Referencia de límites desde backend SSOT. Cambiar nível en o formulário de edición aplica estos valores (sobrescritos aún posibles).",
        "columns": {
          "org": "Organização",
          "tier": "Nível",
          "fiveHour": "5h",
          "week": "Semana",
          "month": "Mês",
          "features": "Funcionalidades"
        },
        "tierDefaults": {
          "fiveHour": "5h (req / tok)",
          "week": "Semana (req / tok)",
          "month": "Mês (req / tok)"
        }
      },
      "usage": {
        "title": "Uso do agente",
        "subtitle": "Log de chamadas de agente por organização",
        "orgIdPlaceholder": "Org ID",
        "allFeatures": "Todas as funcionalidades",
        "empty": "Nenhum evento de utilização encontrado",
        "columns": {
          "time": "Tempo",
          "org": "Organização",
          "user": "Usuario",
          "feature": "Característica",
          "tokens": "Tokens"
        }
      },
      "audit": {
        "title": "Auditoria tool-calls",
        "subtitle": "Log de chamadas MCP (especialmente write-actions)",
        "orgIdPlaceholder": "Org ID",
        "toolPlaceholder": "Nombre da ferramenta",
        "writeOnly": "Escribir ferramentas solo",
        "detailTitle": "Detalhe de auditoria",
        "detail": "Detalhe",
        "empty": "Nenhum registo de auditoria encontrado",
        "write": "Escribir",
        "read": "Leer",
        "columns": {
          "time": "Tempo",
          "org": "Organização",
          "tool": "Ferramenta",
          "write": "Escribir"
        }
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Excluir projeto",
        "message": "Esta ação não pode ser desfeita. Todos os formulários vinculados serão removidos.",
        "formsCount": "Formulários a remover: {count}",
        "confirm": "Excluir permanentemente"
      },
      "deleteOrganization": {
        "title": "Excluir organização",
        "message": "Esta ação não pode ser desfeita. Todos os projetos e usuários serão afetados.",
        "confirm": "Excluir permanentemente"
      },
      "deleteForm": {
        "title": "Excluir formulário",
        "message": "Esta ação não pode ser desfeita.",
        "confirm": "Excluir permanentemente"
      },
      "deleteUser": {
        "title": "Excluir usuário",
        "message": "Esta ação não pode ser desfeita. O usuário perderá acesso a todas as organizações.",
        "confirm": "Excluir permanentemente"
      },
      "projectDetails": "Projeto: {name}",
      "organizationDetails": "Organização: {name}",
      "formDetails": "Formulário: {name}",
      "userDetails": "Usuário: {name}",
      "close": "Fechar",
      "createUser": {
        "title": "Criar usuário"
      },
      "editUser": {
        "title": "Editar usuário"
      },
      "fullName": "Nome completo",
      "superuser": "Superusuário",
      "active": "Ativo"
    },
    "back": "Volver al dashboard",
    "chrome": {
      "sessionLabel": "Superutilizador · todas as ações registadas",
      "exit": "Modo de salida",
      "menuTitle": "Administração",
      "sessionWarning": "A sesión de administrador expira en {time}.",
      "extendSession": "Prolongar sessão"
    },
    "nav": {
      "groups": {
        "overview": "Visão geral",
        "directory": "Diretório",
        "access": "Acesso",
        "integrations": "Integrações",
        "platform": "Plataforma"
      },
      "dashboard": "Painel",
      "analytics": "Análise",
      "users": "Utilizadores",
      "organizations": "Organizações",
      "projects": "Projetos",
      "forms": "Formulários",
      "roles": "Funções e permissões",
      "permissionGroups": "Grupos de permissões",
      "agent": "Hermes Agent",
      "agentDashboard": "Painel do agente",
      "agentSubscriptions": "Subscrições do agente",
      "agentUsage": "Utilização do agente",
      "agentAudit": "Auditoria do agente",
      "globalOdk": "Servidores ODK globais",
      "system": "Sistema",
      "audit": "Auditoria",
      "subscriptions": "Faturação"
    },
    "pagination": {
      "shown": "A mostrar {start} - {end} de {total}",
      "pageOf": "Página {page} de {pages}",
      "previous": "Anterior",
      "next": "Seguinte"
    },
    "common": {
      "tryAgain": "Tentar novamente",
      "showDeleted": "Mostrar eliminados",
      "hideDeleted": "Ocultar eliminados",
      "showArchived": "Mostrar arquivados",
      "hideArchived": "Ocultar arquivados",
      "allOrganizations": "Todas as organizações",
      "allProjects": "Todos os projetos",
      "allRoles": "Todas as funções",
      "allStatuses": "Todos os estados",
      "totalRecords": "Total de registos: {count}",
      "orgIdPrefix": "Org #{id}",
      "projectIdPrefix": "Project #{id}",
      "notSet": "Não definido",
      "health": {
        "healthy": "Saudável",
        "degraded": "Degradado",
        "disabled": "Desativado",
        "unhealthy": "Não saudável",
        "unknown": "Desconhecido"
      }
    },
    "pages": {
      "users": {
        "title": "Gestão de utilizadores",
        "subtitle": "Ver e gerir todos os utilizadores do sistema",
        "addUser": "Adicionar utilizador",
        "searchPlaceholder": "Pesquisar utilizadores...",
        "superuserBadge": "Superutilizador",
        "userBadge": "Usuario",
        "statsTotal": "Total",
        "statsSuperusers": "Superutilizadors",
        "statsOwners": "Proprietários",
        "statsActive": "Ativo",
        "loadError": "Não foi possível carregar os utilizadores",
        "empty": "Nenhum utilizador corresponde aos filtros atuais"
      },
      "organizations": {
        "title": "Gestão de organizações",
        "subtitle": "Ver e gerir todas as organizações do sistema",
        "searchPlaceholder": "Pesquisar por nome ou descrição da organização...",
        "sectionTitle": "Organizações",
        "loading": "A carregar organizações...",
        "empty": "Nenhuma organização encontrada",
        "loadError": "Não foi possível carregar as organizações",
        "restored": "Organização restaurada",
        "restoreError": "Não foi possível restaurar a organização",
        "owner": "Proprietário",
        "created": "Criado",
        "deletedBadge": "Eliminado",
        "activeBadge": "Ativo",
        "agentSubscription": "Subscrição do agente",
        "statsTotal": "Total de organizações",
        "statsActive": "Ativo",
        "statsProjects": "Projetos",
        "statsForms": "Formulários"
      },
      "projects": {
        "title": "Gestão de projetos",
        "subtitle": "Ver e gerir todos os projetos do sistema",
        "searchPlaceholder": "Pesquisar por nome ou descrição do projeto...",
        "sectionTitle": "Projetos",
        "loading": "A carregar projetos...",
        "empty": "Nenhum projeto encontrado",
        "loadError": "Não foi possível carregar os projetos",
        "archived": "Projeto arquivado",
        "unarchived": "Projeto desarquivado",
        "archiveError": "Não foi possível arquivar o projeto",
        "unarchiveError": "Não foi possível desarquivar o projeto",
        "created": "Criado",
        "archivedBadge": "Arquivado",
        "activeBadge": "Ativo",
        "statsTotal": "Total de projetos",
        "statsActive": "Ativo",
        "statsArchived": "Arquivado",
        "statsForms": "Formulários"
      },
      "forms": {
        "title": "Gestão de formulários",
        "subtitle": "Ver e gerir todos os formulários do sistema",
        "searchPlaceholder": "Pesquisar por nome ou ID XML do formulário...",
        "sectionTitle": "Formulários",
        "loading": "A carregar formulários...",
        "empty": "Nenhum formulário encontrado",
        "loadError": "Não foi possível carregar os formulários",
        "deletedToast": "Formulário marcado como eliminado",
        "restoredToast": "Formulário restaurado",
        "deleteError": "Não foi possível eliminar o formulário",
        "restoreError": "Não foi possível restaurar o formulário",
        "created": "Criado",
        "deletedBadge": "Eliminado",
        "activeBadge": "Ativo",
        "importedBadge": "Importado",
        "statsTotal": "Total de formulários",
        "statsActive": "Ativo",
        "statsDeleted": "Eliminado",
        "statsImported": "Importado"
      },
      "permissionGroups": {
        "title": "Grupos de permissões",
        "subtitle": "Gerir grupos de permissões e atribuí-los a utilizadores",
        "createGroup": "Criar grupo",
        "sectionTitle": "Grupos de permissões",
        "searchPlaceholder": "Pesquisar grupos...",
        "emptyFilter": "Nenhum grupo corresponde à pesquisa atual",
        "restoreError": "Não foi possível restaurar o grupo de permissões",
        "deleteError": "Não foi possível eliminar o grupo de permissões",
        "emptyTitle": "Nenhum grupo de permissões encontrado",
        "emptyBody": "Crie o primeiro grupo de permissões para começar",
        "deleteTitle": "Eliminar grupo",
        "deleteMessage": "Tem a certeza de que deseja eliminar o grupo \"{name}\"? Esta ação não pode ser desfeita.",
        "restoreTitle": "Restaurar",
        "users": "Utilizadores",
        "statsTotal": "Total de grupos",
        "statsActive": "Grupos ativos",
        "statsAssignments": "Atribuições",
        "loadError": "Não foi possível carregar os grupos de permissões",
        "restored": "Grupo \"{name}\" restaurado",
        "deleted": "Grupo de permissões eliminado",
        "saved": "Grupo de permissões guardado",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Servidores ODK globais",
        "subtitle": "Criar e gerir servidores ODK globais",
        "createServer": "Criar servidor",
        "statsTotal": "Total de servidores",
        "statsTotalHint": "{count} (+{active} ativos)",
        "statsGlobal": "Globais",
        "statsDefault": "Predefinido",
        "testTitle": "Resultado do teste de ligação",
        "testOk": "Ligação bem-sucedida",
        "testFail": "Ligação falhada",
        "testMethod": "Método:",
        "testProjects": "Total de projetos:",
        "testing": "A testar ligação...",
        "refreshTokenTitle": "Atualizar token API",
        "refreshTokenBody": "Introduza a palavra-passe para atualizar o token API do servidor",
        "password": "Palavra-passe",
        "passwordPlaceholder": "Introduza a palavra-passe",
        "refreshTokenAction": "Atualizar token",
        "requiredField": "Este campo é obrigatório",
        "searchPlaceholder": "Pesquisar por nome, URL ou nome de utilizador...",
        "empty": "Nenhum servidor ODK global encontrado",
        "emptyHint": "Crie o primeiro servidor ODK global para começar.",
        "emptyFilter": "Nenhum servidor corresponde à pesquisa atual",
        "defaultBadge": "Predefinido",
        "columns": {
          "server": "Servidor",
          "user": "Usuario",
          "visibility": "Visibilidadee"
        },
        "visibility": {
          "GLOBAL": "Global",
          "ORGANIZATION": "Organização",
          "SHARED": "Partilhado"
        },
        "actions": {
          "test": "Testar ligação",
          "refreshToken": "Atualizar token",
          "setDefault": "Definir como predefinido"
        },
        "deleteTitle": "Eliminar servidor",
        "deleteMessage": "Eliminar o servidor \"{name}\"? Esta ação não pode ser desfeita.",
        "setDefaultTitle": "Definir servidor predefinido",
        "setDefaultMessage": "Definir \"{name}\" como servidor ODK global predefinido?",
        "setDefaultConfirm": "Definir",
        "toastCreated": "Servidor criado",
        "toastUpdated": "Servidor atualizado",
        "toastDeleted": "Servidor eliminado",
        "toastTestOk": "Ligação bem-sucedida",
        "toastTokenRefreshed": "Token API actualizado",
        "toastDefaultSet": "Servidor global predefinido actualizado",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Subscrições de faturação",
        "subtitle": "Faturação SaaS e planos de pagamento (não quotas do Hermes Agent)",
        "stubBadge": "Em breve",
        "stubBody": "As subscrições de faturação e pagamento estão em desenvolvimento. Esta página irá gerir os planos comerciais quando a faturação for lançada.",
        "stubAgentHint": "Os níveis, quotas e flags de funcionalidades do Hermes Agent são geridos em Integrações → Hermes Agent → Subscrições.",
        "openAgentSubscriptions": "Abrir subscrições do agente"
      },
      "audit": {
        "title": "Auditoria de acciones",
        "subtitle": "Registro de acciones administrativas de superutilizadores",
        "loadError": "Não foi possível carregar o registro de auditoria.",
        "empty": "Ainda não há registos de auditoria",
        "time": "Tempo",
        "user": "Usuario",
        "action": "Ação",
        "details": "Detalhes",
        "emptyFilter": "Ningún registro coincide con la pesquisa actual",
        "searchPlaceholder": "Pesquisar por utilizador, ação o detalhes...",
        "actionKey": "Chave de ação",
        "detailTitle": "Entrada de auditoria"
      },
      "system": {
        "title": "Saúde do sistema",
        "subtitle": "Diagnósticos de infraestrutura — estado, latência e detalhes de execução",
        "loadError": "Não foi possível carregar o estado do sistema.",
        "serverInfo": "Detalhes de execução",
        "version": "Versão",
        "uptime": "Tempo de atividade do proceso",
        "dbConnections": "Conexiones a BD (ativas)",
        "dbPool": "Tamaño do grupo de BD",
        "components": {
          "server": "Servidor",
          "database": "Base de dados",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        },
        "attentionTitle": "Precisa de atenção",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Abrir agente",
        "componentsTitle": "Componentes",
        "dbLatency": "Latência da BD",
        "apiLatency": "Latência da API"
      },
      "analytics": {
        "title": "Painel de análise",
        "subtitle": "Análise do sistema e dos utilizadores",
        "loadError": "Não foi possível carregar as análises. A mostrar valores zero.",
        "totalUsers": "Total de utilizadores",
        "thisMonth": "+{count} este mês",
        "organizations": "Organizações",
        "growthPct": "{pct}% de crescimento",
        "totalProjects": "Total de projetos",
        "totalForms": "Total de formulários",
        "submissions": "Submissões",
        "userGrowth": "Crecimiento de utilizadores (por mês)",
        "orgActivity": "Atividade das organizações (por projetos)",
        "noData": "Sin datos",
        "topOrgs": "Principales organizações",
        "projectsCount": "{count} projetos",
        "noOrgs": "Sin organizações",
        "recentActivity": "Atividade recente",
        "noRecent": "Sin atividade recente",
        "systemHealth": "Saúde do sistema",
        "resources": "Utilização de recursos",
        "orgs": "Organizações",
        "projects": "Projetos",
        "forms": "Formulários",
        "health": {
          "api": "API",
          "database": "Base de dados",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Funções e permissões",
        "subtitle": "Catálogo de funções da plataforma — blocos para grupos de permissões",
        "searchPlaceholder": "Pesquisar funções...",
        "loadError": "Não foi possível carregar as funções.",
        "emptyTitle": "Nenhuma função encontrada",
        "emptyFilter": "Nenhuma função corresponde à pesquisa",
        "openGroups": "Grupos de permissões",
        "system": "Sistema",
        "custom": "Personalizado",
        "unused": "Não usado em nenhum grupo",
        "columns": {
          "role": "Função",
          "description": "Descrição",
          "usedIn": "Usado em grupos",
          "type": "Tipo"
        },
        "labels": {
          "project_member": "Membro do projeto"
        },
        "descriptions": {
          "fallback": "Nenhuma descrição disponível.",
          "manager": "Gestão completa do projeto e supervisão de qualidade.",
          "project_member": "Acesso mínimo ao projeto — nome e formulários, sem dados de submissões.",
          "data_viewer": "Acesso somente leitura a submissões, monitoramento e revisão QC.",
          "data_collector": "Coletar e enviar dados de campo.",
          "data_downloader": "Exportar e baixar dados de submissões.",
          "data_analyst": "Operações QC e análise de dados.",
          "form_designer": "Criar e gerir formulários XLSForm.",
          "qc_editor": "Editar resultados e achados QC."
        }
      }
    },
    "dashboard": {
      "title": "Visão geral",
      "subtitle": "Estado da plataforma e atividade administrativa recente",
      "errors": {
        "stats": "Não foi possível carregar as métricas do sistema. A mostrar zeros.",
        "health": "Não foi possível carregar o estado do sistema.",
        "activities": "Não foi possível carregar a atividade recente."
      },
      "attention": {
        "title": "Precisa de atenção",
        "server": "O servidor reporta um estado não saudável.",
        "database": "A base de dados reporta um estado não saudável.",
        "redis": "O Redis reporta um estado não saudável.",
        "api": "A API reporta um estado não saudável.",
        "agent": "Estado do Hermes Agent: {status}.",
        "failedLogins": "{count} tentativas de início de sessão falhadas nas últimas 24 horas.",
        "openSystem": "Abrir sistema",
        "openAgent": "Abrir agente",
        "openAudit": "Abrir auditoria"
      },
      "sections": {
        "metrics": "Diretório",
        "health": "Estado",
        "activity": "Atividade recente"
      },
      "metrics": {
        "users": "Utilizadores",
        "usersHint": "+{count} hoje",
        "orgs": "Organizações",
        "orgsHint": "+{count} esta semana",
        "projects": "Projetos",
        "projectsHint": "{count} ativos",
        "failedLogins": "Inícios de sessão falhados",
        "failedLoginsHint": "Últimas 24 horas"
      },
      "health": {
        "server": "Servidor",
        "database": "Base de dados",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "{count} ligações",
        "latency": "{ms} ms",
        "agentHint": "{count} ped. hoje"
      },
      "activity": {
        "viewAll": "Ver auditoria",
        "empty": "Sem atividade administrativa recente"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Carregando subscrição do agente...",
      "working": "O agente está trabalhando..."
    },
    "features": {
      "reports": "Relatórios",
      "qc": "Assistente QC",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "errors": {
      "generic": "Falha ao chamar o agente.",
      "endpointNotFound": "Esta funcionalidade do agente não está disponível no backend em execução. Reinicie o servidor backend dev (.\\scripts\\dev.ps1).",
      "timeout": "O agente não respondeu no tempo. O assistente XLSForm pode levar até 10 minutos — tente novamente.",
      "featureUnavailable": "Esta funcionalidade não está disponível no seu plano.",
      "quotaExceeded": "Quota do agente excedida para este período.",
      "disabled": "O agente AI está temporariamente desabilitado.",
      "mcpUnavailable": "Hermes não pode ver as ferramentas MCP udacapi. Registre MCP no CT253 (grant-udacapi-mcp.sh) e verifique a relação :8101 → backend :8100. Veja runbooks/hermês-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Limite mensal de pedidos atingido",
          "tokens": "Limite mensal de tokens atingido"
        },
        "five_hour": {
          "requests": "Limite de pedidos de 5 horas atingido",
          "tokens": "Limite de tokens de 5 horas atingido"
        },
        "weekly": {
          "requests": "Limite semanal de pedidos atingido",
          "tokens": "Limite semanal de tokens atingido"
        }
      },
      "usageLine": "{used} de {limit} usados",
      "resetsAt": "Disponível novamente {relative} ({absolute})",
      "resetsUnknown": "Tente novamente mais tarde ou contate seu administrador para aumentar os limites.",
      "viewSubscription": "Ver detalhes da quota",
      "sendBlocked": "Quota do agente esgotada — aguarde a reinicialização do limite.",
      "nearLimit": "Quota do agente quase esgotada ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Funcionalidade bloqueada",
      "lockedDescription": "\"{feature}\" está disponível no plano {tier} e acima."
    },
    "subscription": {
      "sectionTitle": "Agente AI",
      "sectionDescription": "O tier, quotas e funcionalidades habilitadas do agente da sua organização.",
      "currentTier": "Tier atual",
      "active": "Ativo",
      "inactive": "Inativo",
      "features": "Funcionalidades habilitadas",
      "tier": "Plano",
      "capabilities": "Capacidades",
      "billingPeriod": "Início do período de cobrança",
      "requests": "Solicitações neste período",
      "requests_5h": "Solicitações (últimas 5h)",
      "requests_weekly": "Solicitações (última semana)",
      "requests_badge": "sol.",
      "requests_5h_badge": "sol. (5h)",
      "requests_weekly_badge": "sol. (sem.)",
      "tokens": "Tokens neste período",
      "tokens_5h": "Tokens (últimas 5h)",
      "tokens_weekly": "Tokens (última semana)",
      "nearQuotaTitle": "Limite de quota próximo",
      "nearQuotaDescription": "Mais de 80% da quota mensal está sendo usada. Contate seu administrador para aumentar os limites.",
      "tiers": {
        "free": "Grátis",
        "pro": "Pro",
        "enterprise": "Enterprise"
      },
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked."
    },
    "report": {
      "title": "Relatório AI para PM",
      "description": "Resumo de submissões preparado pelo agente AI da UDA.",
      "period": "Período (dias)",
      "generate": "Gerar relatório",
      "generating": "O agente está preparando o relatório...",
      "empty": "Clique em \"Gerar relatório\" para obter um resumo.",
      "modeSummary": "Resumo",
      "modeAnalytical": "Analítico",
      "modeScheduled": "Por modelo",
      "quotaExceeded": "Quota do agente excedida para este período.",
      "featureUnavailable": "Relatórios AI não estão disponíveis no seu plano.",
      "error": "Falha ao obter o relatório do agente.",
      "healthAlerts": "Notas de saúde do formulário",
      "copy": "Copiar relatório",
      "copied": "Copiado",
      "copyFailed": "Não foi possível copiar para a área de transferência.",
      "viewFormatted": "Formatado",
      "viewRaw": "Markdown",
      "templates": {
        "title": "Modelos de relatórios",
        "subtitle": "Configure agendamentos e prompts de IA para esta organização.",
        "create": "Novo modelo",
        "createTitle": "Criar modelo de relatório",
        "edit": "Editar",
        "editTitle": "Editar modelo de relatório",
        "formSubtitle": "Defina o que o relatório cobre, quando é executado e quem o recebe.",
        "sections": {
          "content": "Conteúdo do relatório",
          "schedule": "Agendamento",
          "delivery": "Entrega e abrangência"
        },
        "seed": "Carregar valores predefinidos",
        "seeded": "Se añadieron {count} modelo(s).",
        "empty": "Sem modelos aún. Carga os valores predefinidos o crea una.",
        "active": "Ativo",
        "inactive": "Inativo",
        "cron": "Agendamento",
        "sendByEmail": "Enviar por e-mail",
        "deactivate": "Desativar",
        "deactivated": "Modelo desativada.",
        "activate": "Ativar",
        "activated": "Modelo ativado.",
        "save": "Guardar",
        "saved": "Modelo guardado.",
        "saveError": "Não foi possível guardar o modelo.",
        "loadError": "Não foi possível carregar os modelos de relatórios.",
        "validationRequired": "O nome e o prompt são obrigatórios.",
        "recipientsPlaceholder": "Selecione membros da organização",
        "recipientsRequired": "Selecione pelo menos um destinatário quando o e-mail estiver ativado.",
        "promptHint": "O acesso aos dados da organização, aos formulários selecionados e ao período é adicionado automaticamente.",
        "allFormsPlaceholder": "Todos os formulários (deixar vazio)",
        "advancedMode": "Prompt personalizado (avançado, Jinja2)",
        "fields": {
          "name": "Nome",
          "audience": "Público",
          "prompt": "Instruções do relatório",
          "responseLanguage": "Idioma da resposta",
          "recipients": "Destinatários",
          "formScope": "Formulários"
        },
        "schedule": {
          "label": "Agendamento",
          "none": "Sem agendamento",
          "daily": "Diário",
          "weekly": "Semanal",
          "monthly": "Mensal",
          "custom": "Personalizado (cron)",
          "time": "Hora",
          "weekday": "Dia da semana",
          "dayOfMonth": "Dia do mês",
          "customCron": "Expressão cron",
          "humanDaily": "A cada día às {time}",
          "humanWeekly": "A cada {weekday} às {time}",
          "humanMonthly": "O día {day} de a cada mês às {time}",
          "weekdays": {
            "0": "Domingo",
            "1": "Segunda-feira",
            "2": "Terça-feira",
            "3": "Quarta-feira",
            "4": "Quinta-feira",
            "5": "Sexta-feira",
            "6": "Sábado"
          }
        },
        "audience": {
          "pm": "Gestor de projeto",
          "field_coord": "Coordenador de campo",
          "statistician": "Estatístico",
          "executive": "Executivo"
        }
      }
    },
    "chat": {
      "modeAsk": "Perguntar ao agente",
      "description": "Pergunte sobre o schema do formulário, submissões, análises, regras QC e status de sincronização. As respostas são baseadas em dados em tempo real; as submissões de exemplo podem conter campos pessoais.",
      "question": "Sua pergunta",
      "placeholder": "e.g. Quantas submissões no último 7 dias? Quais campos este formulário tem?",
      "send": "Enviar",
      "empty": "Pergunte sobre os dados deste formulário.",
      "you": "Você",
      "agent": "Agente",
      "generating": "O agente está procurando os dados do formulário...",
      "sendHint": "Enter to send · Shift+Enter for a new line"
    },
    "analytical": {
      "generate": "Executar relatório analítico",
      "empty": "Executar um relatório analítico para análise detalhada do formulário.",
      "queued": "Relatório em fila...",
      "status": "Estado: {status}",
      "done": "Relatório pronto.",
      "failed": "Falha ao gerar o relatório analítico.",
      "emptyResult": "O relatório terminou, mas não retornou conteúdo.",
      "timeout": "O relatório analítico demorou demais. Verifique se o worker de relatórios do agente está em execução.",
      "workerHint": "O job ainda está na fila. Inicie o serviço agent-reports-worker (docker compose up -d agent-reports-worker) e tente novamente."
    },
    "qc": {
      "title": "Assistente QC AI",
      "description": "Descreva uma verificação em linguagem simples — o agente irá esboçar uma regra QC.",
      "checkDescription": "Descrição da verificação",
      "checkPlaceholder": "e.g. a idade do respondente deve estar entre 18 e 65",
      "suggest": "Sugerir regra",
      "generating": "O agente está esboçando uma regra...",
      "applyDraft": "Aplicar esboço ao formulário",
      "draftApplied": "Esboço aplicado ao formulário.",
      "draftPreview": "Regra sugerida",
      "viewRawResponse": "Visualizar resposta completa do agente",
      "sendHint": "Enter para sugerir · Shift+Enter para uma nova linha",
      "noDraftParsed": "Não foi possível analisar o JSON de esboço de regra da resposta do agente.",
      "validationWarnings": "Notas de validação ({count}):",
      "starterPack": {
        "title": "Regras de início QC",
        "description": "Revise o formulário e obtenha um conjunto de regras sugeridas para começar a validação.",
        "focus": "Foco",
        "focusAll": "Mix balanceado",
        "focusRequired": "Apenas campos obrigatórios",
        "focusConstraints": "Apenas restrições",
        "maxRules": "Max regras",
        "suggest": "Sugerir regras de início",
        "generating": "Revisando o formulário e esboçando regras...",
        "apply": "Aplicar esta regra",
        "empty": "Nenhum esboço de regra válido foi retornado. Tente novamente ou use a sugestão de regra única acima.",
        "skippedHint": "{count} regra(s) sugerida(s) foram ignorada(s) (duplicada, inválida ou acima do limite)."
      }
    },
    "xlsform": {
      "openButton": "XLSForm AI",
      "title": "Assistente XLSForm AI",
      "description": "Upload um arquivo de perguntas ou descreva a tarefa — o agente irá esboçar, testar e solicitar confirmação de publicação.",
      "instruction": "Instrução para o agente",
      "instructionPlaceholder": "e.g. criar um formulário de satisfação com 5 perguntas",
      "empty": "Descreva qual formulário você precisa ou envie um arquivo — o agente irá esboçar e testar.",
      "send": "Enviar",
      "sendHint": "Enter para enviar · Shift+Enter para uma nova linha",
      "working": "O agente está trabalhando na tarefa...",
      "you": "Você",
      "agent": "Agente",
      "publishTitle": "Confirmação de publicação",
      "publishDescription": "O agente solicitou a publicação de um rascunho. Confirme manualmente — a publicação não pode prosseguir sem confirmação.",
      "formId": "Form ID (xmlFormId)",
      "versionOptional": "Versão (opcional)",
      "confirmPublish": "Confirmar publicação",
      "upload": {
        "hint": "Anexe Excel/CSV, Word ou texto com suas perguntas (máx. 5 MB)",
        "attachAria": "Anexar arquivo",
        "removeAttachment": "Remover anexo",
        "selected": "Arquivo: {name}",
        "attachmentPrefix": "[file: {name}]"
      },
      "session": {
        "resumeBanner": "Você tem uma sessão AI XLSForm (rascunho: {formId})",
        "resumeButton": "Continuar",
        "startNewButton": "Começar de novo",
        "dismissButton": "Descartar",
        "dismissError": "Não foi possível descartar a sessão. Tente novamente.",
        "historyButton": "Sessões anteriores",
        "historyTitle": "Sessões AI XLSForm",
        "historyHint": "Sessões dos últimos 7 dias. Continue um rascunho ou veja uma sessão publicada.",
        "historyEmpty": "Nenhuma sessão anterior para este projeto.",
        "historyFormColumn": "Rascunho",
        "historyStatusColumn": "Estado",
        "historyUpdatedColumn": "Atualizado",
        "historyMessagesColumn": "Mensagens",
        "historyActionsColumn": "Ações",
        "continueButton": "Continuar",
        "viewButton": "Ver",
        "continueError": "Não foi possível retomar a sessão. Tente novamente.",
        "readOnlyHint": "Esta sessão foi publicada. Você pode revisar o histórico, mas não enviar novas mensagens.",
        "draftUnknown": "sem nome",
        "status": {
          "active": "Ativa",
          "discarded": "Descartada",
          "failed": "Falhou",
          "published": "Publicada"
        }
      },
      "job": {
        "canClose": "Você pode fechar esta janela — sua sessão continuará em segundo plano.",
        "elapsed": "Trabalhando… {time}",
        "agentWorking": "O agente está a processar o seu pedido (LLM e ferramentas MCP). Este passo pode demorar vários minutos.",
        "longWait": "Ainda trabalhando — verifique se o proxy LLM e o relay Hermes MCP estão saudáveis se isso levar mais de 10 minutos.",
        "timeout": "O assistente de formulário não terminou a tempo. A sessão com falha foi redefinida; tente novamente em uma nova sessão.",
        "failed": "O assistente de formulário falhou. Tente novamente.",
        "phases": {
          "queued": "Em fila",
          "planning": "Analisando sua pedido",
          "editing": "Editando perguntas do formulário",
          "uploading_draft": "Criando rascunho de formulário",
          "testing_draft": "Testando rascunho",
          "finalizing": "Preparando resposta",
          "completed": "Concluído"
        },
        "queuedFallback": "O trabalhador ainda não pegou a tarefa — o servidor reverterá em breve."
      },
      "preview": {
        "tabChat": "Conversa",
        "tabPreview": "Pré-visualização",
        "loading": "Carregando a pré-visualização do formulário…",
        "empty": "Nenhum rascunho para pré-visualizar ainda. Peça ao assistente para criar ou editar o formulário.",
        "error": "Não foi possível carregar a pré-visualização do formulário.",
        "submitError": "Não foi possível enviar a submissão de teste."
      }
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Sincronização concluída: {formName}. {count} de {total} registos processados",
      "syncError": "Erro de sincronização: {formName}. {error}",
      "formStatusChange": "Status do formulário alterado: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Agendador: {status}. Trabalhos ativos: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "Validação QC concluída: {instanceId}. Regras: {totalRules}, aprovadas: {passedRules}, erros: {errorRules}, avisos: {warningRules}",
      "projectStatusSummary": "Mudanças críticas: {errorProjects} projetos com erros, {errorForms} formulários com erros de {totalProjects} projetos e {totalForms} formulários"
    },
    "connection": {
      "connected": "WebSocket conectado",
      "disconnected": "WebSocket desconectado",
      "reconnecting": "Reconectando...",
      "error": "Erro WebSocket: {error}",
      "maxRetriesReached": "Número máximo de tentativas de reconexão atingido"
    },
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "realTimeUpdates": "Atualizações em tempo real"
  },
  "buttonSelect": {
    "dark": "Escuro",
    "light": "Claro"
  },
  "odkOptions": {
    "themes": {
      "light": "Claro",
      "dark": "Escuro"
    },
    "navigation": {
      "swipe": "Deslizar",
      "buttons": "Botões",
      "swipe_buttons": "Deslizar + Botões"
    },
    "formUpdate": {
      "manual": "Manual",
      "previously_downloaded": "Previo descargado",
      "match_exactly": "Corresponder exatamente"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "A a cada 15 minutos",
      "every_one_hour": "A a cada 1 hora",
      "every_six_hours": "A a cada 6 horas",
      "every_24_hours": "A a cada 24 horas"
    },
    "autosend": {
      "off": "Desativado",
      "wifi_only": "Apenas Wi‑Fi",
      "cellular_only": "Apenas dados móveis",
      "wifi_and_cellular": "Wi‑Fi e dados móveis"
    },
    "constraintBehavior": {
      "on_swipe": "Ao deslizar",
      "on_finalize": "Ao finalizar"
    },
    "imageSizes": {
      "original": "Original",
      "very_small": "Muito pequeno",
      "small": "Pequeno",
      "medium": "Médio",
      "large": "Grande"
    },
    "guidanceHint": {
      "no": "No",
      "yes": "Sim",
      "yes_collapsed": "Sim (colapsado)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Normal",
      "terrain": "Terreno",
      "hybrid": "Híbrido",
      "satellite": "Satélite",
      "light": "Claro",
      "dark": "Escuro",
      "satellite_streets": "Satélite + ruas",
      "outdoors": "Aire libre",
      "topographic": "Topográfico",
      "positron": "Positron",
      "dark_matter": "Dark matter"
    },
    "fontSizes": {
      "small": "Pequeno",
      "normal": "Normal",
      "large": "Grande",
      "xl": "XL",
      "xxl": "XXL"
    }
  },
  "users": {
    "title": "Usuários",
    "subtitle": "Gerencie os membros da organização, filtre por atividade e atualize os registos de acesso.",
    "searchUser": "Pesquisar usuário",
    "addUser": "Adicionar usuário",
    "editUser": "Editar usuário",
    "deleteUser": "Excluir usuário",
    "firstName": "Primeiro nome",
    "lastName": "Sobrenome",
    "fullName": "Nome completo",
    "email": "Email",
    "password": "Senha",
    "confirmPassword": "Confirmar senha",
    "enterEmail": "Digite o email",
    "userCreated": "Usuário criado com sucesso",
    "userUpdated": "Usuário atualizado com sucesso",
    "userDeleted": "Usuário excluído com sucesso",
    "confirmDeleteUser": "Tem certeza de que deseja excluir este usuário?",
    "projectSelection": {
      "archived": "Arquivado",
      "noProjects": "Nenhum projeto disponível",
      "noProjectsDescription": "Nenhum projeto disponível para atribuição",
      "errorLoadingProjects": "Erro ao carregar projetos"
    },
    "admin": "Administrador",
    "data_collector": "Coletor de dados",
    "supervisor": "Supervisor(a)",
    "user": "Usuário",
    "owner": "Proprietário",
    "isClient": "Cliente",
    "active": "Ativo",
    "inactive": "Inativo",
    "refresh": "Atualizar",
    "unsavedChanges": "O formulário tem alterações não salvas. Tem certeza de que deseja fechá-lo?",
    "validation": {
      "passwordRequired": "A senha é obrigatória",
      "passwordMinLength": "A senha deve ter pelo menos 8 caracteres",
      "confirmPasswordRequired": "Por favor, confirme a senha",
      "passwordsDontMatch": "As senhas não coincidem"
    },
    "editUserDescription": "Atualizar detalhes do usuário",
    "addUserDescription": "Criar um novo usuário no sistema",
    "basicInformation": "Informações Básicas",
    "fullNamePlaceholder": "Digite o nome completo",
    "passwordSettings": "Configurações de Senha",
    "passwordPlaceholder": "Digite a senha",
    "confirmPasswordPlaceholder": "Confirme a senha",
    "passwordHelp": "A senha deve ter pelo menos 8 caracteres",
    "userSettings": "Configurações de Usuário",
    "clientUserDescription": "O usuário cliente tem acesso limitado",
    "inactiveUserDescription": "Usuários inativos não podem fazer login no sistema",
    "noName": "Sem nome"
  },
  "user": {
    "system": "Sistema",
    "account": "Conta",
    "explore": "Explorar",
    "profile": "Perfil",
    "logout": "Sair",
    "settings": "Configurações",
    "projects": "Projetos",
    "faq": "Ajuda",
    "helpAndSupport": "Ajuda e suporte",
    "administration": "Administração",
    "help": "Ajuda"
  },
  "odkSync": {
    "dashboard": {
      "title": "Painel de Sincronização ODK"
    },
    "workbench": {
      "contextHint": "Monitorize a ingestão de dados a partir de servidores ODK e gerencie cursores de sincronização em toda a sua organização.",
      "live": "Atualizações em tempo real",
      "reconnect": "Reconectar",
      "loading": "Carregando dados de sincronização…",
      "schedulerPill": "Agendador",
      "schedulerActive": "Ativo",
      "schedulerPaused": "Pausado",
      "schedulerStopped": "Parado",
      "statusLive": "Em tempo real",
      "statusOffline": "Desconectado",
      "statusSchedulerActive": "Ativo",
      "statusSchedulerPaused": "Pausado",
      "statusSchedulerStopped": "Parado",
      "createShort": "Novo",
      "pipeline": {
        "ariaLabel": "Status da pipeline de sincronização",
        "scheduler": "Agendador",
        "schedulerActive": "Executando de acordo com o programa",
        "schedulerPaused": "Pausado — submissões não sincronizadas",
        "pull": "Última extração",
        "cursors": "Cursores",
        "cursorsHint": "{count} formulários rastreados",
        "cursorsEmpty": "Nenhum cursor ainda"
      }
    },
    "table": {
      "emptyState": "Nenhum cursor de sincronização ainda. Crie um para começar a extrair submissões."
    },
    "scheduler": {
      "title": "Agendador de Sincronização",
      "pauseScheduler": "Pausar agendador",
      "resumeScheduler": "Retomar agendador",
      "pausedMessage": "A sincronização de dados ODK está atualmente pausada. Novas submissões não serão sincronizadas até ser retomada."
    },
    "managerScope": {
      "title": "Visualização de dados de sincronização",
      "message": "Você está visualizando dados de sincronização para {count} projeto(s) que você gerencia. Você pode ver e controlar a sincronização para projetos onde você tem o papel de gerente."
    },
    "statistics": {
      "title": "Estatísticas de Sincronização",
      "totalCursors": "Total de cursores",
      "lastSync": "Última sincronização"
    },
    "cursors": {
      "title": "Cursores de Sincronização",
      "viewModes": {
        "cards": "Cartões",
        "table": "Tabela",
        "projects": "Por Projetos",
        "list": "Lista"
      },
      "actions": {
        "clear": "Limpar",
        "bulkSync": "Sincronização em Massa ({count})",
        "bulkReset": "Redefinição em Massa ({count})",
        "createCursor": "Criar Cursor"
      }
    },
    "auto": {
      "managed": "Automático",
      "manual": "Manual",
      "enableAuto": "Ativar Automático ({count})",
      "disableAuto": "Desativar Automático ({count})",
      "reason": "Motivo",
      "reasons": {
        "importedActive": "Formulário ativo importado",
        "createdActive": "Formulário ativo criado",
        "uploadedActive": "Formulário ativo carregado",
        "formOpened": "Formulário aberto",
        "formClosed": "Formulário fechado",
        "formReopened": "Formulário reaberto",
        "newFormOpened": "Novo formulário aberto",
        "migrated": "Migrado",
        "formNotFound": "Formulário não encontrado",
        "manualOverride": "Sobrescrita manual",
        "formDeleted": "Formulário excluído",
        "importedFormDeleted": "Formulário importado excluído"
      }
    },
    "projectSummary": {
      "forms": "Formulários: {count}",
      "lastSync": "Última Sincronização",
      "active": "Ativos: {count}",
      "errors": "Erros: {count}",
      "inactive": "Inativos: {count}",
      "noProjects": "Sem Projetos",
      "createFirstCursor": "Crie seu primeiro cursor de sincronização"
    },
    "projectResponsible": {
      "responsible": "Responsável",
      "notAssigned": "Não atribuído",
      "assign": "Atribuir",
      "remove": "Remover",
      "assignModal": {
        "title": "Atribuir responsável para o projeto \"{project}\"",
        "selectUser": "Selecionar usuário",
        "selectUserPlaceholder": "Selecionar pessoa responsável",
        "assign": "Atribuir",
        "noUsers": "Nenhum usuário disponível",
        "noUsersMessage": "Não há usuários na organização para atribuir como responsável pelo projeto."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Criar Cursor de Sincronização",
        "server": "Servidor",
        "project": "Projeto",
        "xmlForm": "Formulário XML",
        "serverPlaceholder": "Selecionar servidor",
        "projectPlaceholder": "Selecionar projeto",
        "xmlFormPlaceholder": "Selecionar formulário"
      },
      "manualSync": {
        "title": "Sincronização Manual",
        "selectCursors": "Selecionar Cursores",
        "forceFullSync": "Forçar Sincronização Completa",
        "maxConcurrent": "Máximo de Sincronizações Simultâneas",
        "startSync": "Iniciar Sincronização"
      }
    },
    "messages": {
      "schedulerPaused": "Agendador de sincronização ODK pausado",
      "schedulerResumed": "Agendador de sincronização ODK retomado",
      "cursorCreated": "Cursor de sincronização criado com sucesso",
      "manualSyncTriggered": "Sincronização manual iniciada com sucesso",
      "cursorReset": "Cursor redefinido com sucesso",
      "bulkResetSuccess": "Redefinidos com sucesso {count} cursores",
      "selectCursorsForSync": "Por favor, selecione pelo menos um cursor para sincronização",
      "never": "Nunca"
    },
    "errors": {
      "failedToLoadSyncData": "Falha ao carregar dados de sincronização",
      "failedToControlScheduler": "Falha ao controlar o agendador",
      "failedToCreateCursor": "Falha ao criar cursor de sincronização",
      "failedToTriggerManualSync": "Falha ao iniciar sincronização manual",
      "failedToResetCursor": "Falha ao redefinir cursor",
      "failedToResetSomeCursors": "Falha ao redefinir alguns cursores"
    },
    "filters": {
      "showAllForms": "Mostrar todas as formas",
      "filteringTitle": "Filtragem de formas",
      "filteringMessage": "A mostrar {filtered} de {total} formas. Ocultas {hidden} formas com status 'fechado', 'desconhecido' ou sem status definido."
    },
    "formStatus": {
      "title": "Status das formas e otimização",
      "checkStatuses": "Verificar status",
      "statusLabels": {
        "open": "Abertas",
        "closing": "Fechando",
        "closed": "Fechadas",
        "unknown": "Desconhecido"
      },
      "cards": {
        "title": "Status das formas",
        "description": "Verificar e otimizar cursores",
        "refresh": "Atualizar"
      },
      "loading": "Carregando...",
      "autoCheckInterval": "5 minutos",
      "lastCheck": "Automaticamente a a cada 5 minutos",
      "benefits": {
        "autoDisable": "Desabilitação automática de cursores para formas fechadas",
        "resourceOptimization": "Otimização de recursos de sincronização",
        "performanceImprovement": "Desempenho melhorado"
      },
      "messages": {
        "checkStarted": "Verificação de status das formas iniciada",
        "checkError": "Erro ao verificar status das formas",
        "enableError": "Erro ao habilitar cursores",
        "disableError": "Erro ao desabilitar cursores"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "Painel QC - Qualidade de Dados ODK",
      "description": "Monitoramento da qualidade de dados de submissões ODK usando regras de validação"
    },
    "statistics": {
      "totalRules": "Total de Regras",
      "activeRules": "Regras Ativas",
      "inactiveRules": "Regras Inativas",
      "recentValidations": "Validações Recentes"
    },
    "sections": {
      "rulesByType": "Regras por Tipo",
      "rulesBySeverity": "Regras por Nível de Severidade",
      "qcRules": "Regras QC"
    },
    "filters": {
      "allTypes": "Todos os Tipos",
      "allLevels": "Todos os Níveis",
      "allStatuses": "Todos os Status",
      "active": "Ativo",
      "inactive": "Inativo"
    },
    "actions": {
      "createRule": "Criar Regra",
      "activate": "Ativar",
      "deactivate": "Desativar",
      "clearSelection": "Limpar Seleção"
    },
    "ruleTypes": {
      "required": "Obrigatório",
      "constraint": "Restrição",
      "calculation": "Cálculo",
      "custom": "Personalizado"
    },
    "severityLevels": {
      "error": "Erro",
      "warning": "Aviso",
      "info": "Informação"
    },
    "messages": {
      "noRuleTypeData": "Nenhum dado de tipo de regra disponível",
      "noSeverityData": "Nenhum dado de severidade disponível",
      "ruleUpdated": "Regra atualizada com sucesso",
      "ruleCreated": "Regra criada com sucesso",
      "ruleSaveError": "Erro ao salvar a regra",
      "ruleLoadError": "Erro ao carregar dados",
      "ruleStatusToggled": "Status da regra {ruleName} alterado",
      "ruleStatusError": "Erro ao alterar o status da regra",
      "confirmDeleteRule": "Excluir regra \"{ruleName}\"?",
      "ruleDeleted": "Regra excluída com sucesso",
      "ruleDeleteError": "Erro ao excluir a regra",
      "ruleSaved": "Regra salva com sucesso",
      "bulkStatusToggled": "Status alterado para {count} regras",
      "bulkStatusError": "Erro ao alterar o status das regras",
      "bulkDeleted": "Excluídas {count} regras",
      "bulkDeleteError": "Erro ao excluir as regras",
      "rulesDeleted": "Regras excluídas",
      "rulesActivated": "Regras ativadas",
      "rulesDeactivated": "Regras desativadas",
      "ruleNotFound": "Regra não encontrada",
      "invalidJsonFormat": "Formato JSON inválido",
      "createExpressionFirst": "Criar expressão primeiro",
      "previewError": "Erro durante a visualização",
      "invalidRuleExpression": "Expressão de regra inválida",
      "ruleNotExecuted": "Regra não executada",
      "loadingRule": "Carregando regra...",
      "saving": "Salvando...",
      "loading": "Carregando...",
      "run": "Executar",
      "passed": "Aprovado",
      "failed": "Falhou",
      "success": "Sucesso",
      "errorDuringValidation": "Erro durante a validação",
      "noQcRulesFound": "Nenhuma regra QC encontrada"
    },
    "form": {
      "ruleName": "Nome da Regra",
      "ruleNameRequired": "O nome da regra é obrigatório",
      "fieldPath": "Campo Principal",
      "fieldPathRequired": "O campo principal é obrigatório",
      "fieldPathHint": "O campo principal que esta regra valida. Outros campos podem ser usados na expressão JSONLogic.",
      "errorMessage": "Mensagem de Erro",
      "errorMessageHint": "Mostrado aos revisores quando uma submissão falha esta regra.",
      "errorMessageRequired": "A mensagem de erro é obrigatória",
      "constraintExpression": "Expressão de Restrição",
      "constraintExpressionHint": "Use '{'\"var\": \"field_name\"'}' para referenciar campos de submissão. Clique em Aplicar para validar JSON.",
      "constraintExpressionRequired": "A expressão de restrição é obrigatória",
      "ruleType": "Tipo de Regra",
      "severityLevel": "Nível de Severidade",
      "ruleActive": "A regra está ativa",
      "ruleActiveHint": "Regras inativas são mantidas mas não aplicadas durante a validação.",
      "basicSettings": "Configurações Básicas",
      "jsonLogicBuilder": "Construtor JSONLogic",
      "jsonLogicBuilderHint": "Define quando esta regra passa. A expressão deve avaliar a verdade para submissões válidas.",
      "reset": "Redefinir",
      "apply": "Aplicar",
      "saveChanges": "Salvar Alterações",
      "createRule": "Criar Regra",
      "editRule": "Editar Regra",
      "rulePreview": "Visualização da Regra",
      "testRuleOnSample": "Testar regra em dados de exemplo",
      "detailedResults": "Resultados Detalhados",
      "showSubmissionData": "Mostrar dados de envio",
      "help": "Ajuda",
      "ruleTypes": "Tipos de Regra",
      "severityLevels": "Níveis de Severidade",
      "requiredField": "Campo obrigatório",
      "constraintCheck": "Verificação de restrição",
      "calculatedField": "Campo calculado",
      "customLogic": "Lógica personalizada",
      "blocksSubmission": "Bloqueia envio",
      "showsWarning": "Mostra aviso",
      "informationalMessage": "Mensagem informativa",
      "jsonLogicExamplesTitle": "Exemplos de expressões JSONLogic para hh_question:",
      "agreementCheckExample": "Verificação de acordo:",
      "finalStatusCheckExample": "Verificação de status final:",
      "enumeratorCheckExample": "Verificação de enumerador:",
      "complexLogicExample": "Lógica complexa:",
      "fieldValue": "Valor do campo",
      "previewStatsLine": "{passed} aprovados · {failed} falhados · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Pesquisar por nome, campo ou mensagem...",
      "ruleType": "Tipo de regra",
      "severityLevel": "Nível de severidade",
      "status": "Estado",
      "enterRuleName": "Digite o nome da regra",
      "enterErrorMessage": "Digite a mensagem de erro",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Desabilitar regra",
        "enableRule": "Habilitar regra"
      }
    },
    "viewModes": {
      "cards": "Cartões",
      "table": "Tabela"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "Monitor de Limpeza de Dados ODK",
      "subtitle": "Monitorizar o sistema de limpeza automática e ver estatísticas de dados",
      "selectFormTitle": "Selecionar Formulário para Monitorização de Limpeza",
      "currentProject": "Projeto Atual",
      "searchPlaceholder": "Procurar e selecionar formulário...",
      "systemInfo": {
        "title": "Sistema de Limpeza Automática",
        "activeFormsTitle": "Formulários ativos (abertos/fechando)",
        "activeFormsDesc": "Apenas as 5 pastas mais recentes são mantidas automaticamente. A limpeza ocorre durante a cada sincronização.",
        "closedFormsTitle": "Formulários fechados (fechados)",
        "closedFormsDesc": "Quando um formulário é fechado, 4 pastas são arquivadas automaticamente, deixando 1 para estatísticas.",
        "monitoringTitle": "Monitorização",
        "monitoringDesc": "Selecione um formulário acima para ver estatísticas e monitorizar o sistema de limpeza."
      }
    },
    "manager": {
      "title": "Gestor de Limpeza de Dados ODK",
      "loading": "A carregar dados de limpeza...",
      "noData": {
        "title": "Nenhum dado disponível",
        "meaning": "O que isto significa:",
        "noSubmissions": "Este formulário ainda não tem submissões",
        "noSync": "O formulário não foi sincronizado do ODK Central",
        "noCleanupNeeded": "Nenhuma limpeza é necessária neste momento"
      },
      "errorLoading": "Erro ao carregar dados",
      "stats": {
        "title": "Estatísticas Atuais",
        "totalFolders": "Total de Pastas",
        "totalSize": "Tamanho Total",
        "completeData": "Dados Completos"
      },
      "formInfo": {
        "title": "Informação do Formulário",
        "state": "Estado:",
        "active": "Ativo:",
        "lastSubmission": "Última Submissão:",
        "lastSync": "Última Sincronização:",
        "yes": "Sim",
        "no": "Não"
      },
      "recommendation": {
        "title": "Recomendação de Limpeza",
        "action": "Ação:",
        "reason": "Razão:",
        "requiresApproval": "Requer aprovação para limpeza"
      },
      "buttons": {
        "refresh": "Atualizar Estatísticas",
        "dryRun": "Simulação",
        "cleanupNow": "Limpar Agora",
        "forceCleanup": "Forçar Limpeza"
      },
      "results": {
        "title": "Resultado da Última Limpeza",
        "strategy": "Estratégia:",
        "kept": "Mantido: {count} pastas",
        "deleted": "Eliminado: {count} pastas",
        "archived": "Arquivado: {count} pastas",
        "skipped": "Ignorado: {count} pastas"
      },
      "folders": {
        "title": "Pastas Recentes ({count})",
        "columns": {
          "name": "Nome da Pasta",
          "created": "Criado",
          "size": "Tamanho (MB)",
          "files": "Ficheiros"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Limpeza global concluída com sucesso",
      "globalCleanupFailed": "A limpeza global falhou",
      "errorLoadingProjects": "Erro ao carregar projetos",
      "errorLoadingForms": "Erro ao carregar formulários",
      "noDataOrSync": "Este formulário não tem dados ou ainda não foi sincronizado",
      "statsLoadFailed": "Falha ao carregar estatísticas de limpeza",
      "dryRunSuccess": "Simulação concluída - nenhum ficheiro foi eliminado",
      "dryRunFailed": "A simulação falhou",
      "cleanupNotRecommended": "Limpeza não recomendada para este formulário",
      "cleanupSuccess": "Limpeza concluída com sucesso",
      "cleanupFailed": "A limpeza falhou",
      "forceNotAvailable": "Limpeza forçada não disponível para este formulário",
      "forceConfirm": "Tem a certeza que deseja forçar a limpeza? Esta ação não pode ser desfeita.",
      "forceSuccess": "Limpeza forçada concluída com sucesso",
      "forceFailed": "A limpeza forçada falhou"
    }
  },
  "permissionGroups": {
    "create": "Criar Grupo",
    "delete": "Excluir Grupo",
    "assignToUser": "Atribuir Grupo ao Usuário",
    "removeFromUser": "Remover Grupo do Usuário",
    "roleNames": {
      "manager": "Gerente",
      "projectMember": "Membro do projeto",
      "dataViewer": "Visualizador de Dados",
      "dataCollector": "Coletor de Dados",
      "dataDownloader": "Download de Dados",
      "dataAnalyst": "Analista de Dados",
      "qcViewer": "Visualizador de QC",
      "qcEditor": "Editor de QC",
      "monitor": "Monitor",
      "formDesigner": "Designer de Formulários"
    },
    "userManagement": {
      "clientGroups": "Grupos de Clientes",
      "clientGroupsDescription": "Grupos destinados a usuários externos ou do lado do cliente.",
      "regularGroups": "Grupos Regulares",
      "regularGroupsDescription": "Grupos destinados a membros internos do projeto.",
      "errorTitle": "Não foi possível carregar os grupos",
      "noProjectsTitle": "Selecione um projeto primeiro",
      "noProjectsDescription": "Escolha um projeto antes de atribuir grupos de permissões.",
      "noGroupsTitle": "Nenhum grupo disponível",
      "noGroupsAvailable": "Nenhum grupo disponível para atribuição",
      "errorLoadingGroups": "Erro ao carregar grupos",
      "selectedGroups": "Grupos selecionados",
      "selectedCount": "{count} selecionados",
      "selectedPill": "Selecionado",
      "includedPermissions": "Permissões incluídas",
      "groupDetailsTitle": "Detalhes do grupo",
      "groupDescriptionFallback": "Nenhuma descrição informada.",
      "rolesCount": "Funções: {count}",
      "viewGroupDetails": "Ver funções em {name}"
    }
  },
  "menu": {
    "dashboard": "Painel",
    "my-organization": "Minha organização",
    "userManagement": "Gestão de usuários",
    "organizationStats": "Estatísticas da organização",
    "organizationSettings": "Configurações da organização",
    "projects": "Projetos",
    "odkServers": "Servidores ODK",
    "odkSync": "Sincronização ODK",
    "payments": "Pagamentos",
    "faq": "Ajuda",
    "preferences": "Preferências da conta",
    "settings": "Configurações do aplicativo",
    "billing": "Cobrança",
    "help": "Ajuda"
  },
  "organization": {
    "settingsSubtitle": "Gerencie o perfil da organização, assinatura de IA, mapas e infraestrutura conectada.",
    "profile": {
      "sectionTitle": "Perfil da organização",
      "name": "Nome",
      "description": "Descrição",
      "edit": "Editar",
      "editTitle": "Editar organização",
      "noDescription": "Nenhuma descrição informada",
      "created": "Criada",
      "updated": "Atualizada",
      "loadError": "Falha ao carregar o perfil da organização"
    },
    "infrastructure": {
      "sectionTitle": "Infraestrutura conectada",
      "subtitle": "Resumo de servidores, projetos, usuários e formulários ativos.",
      "servers": "Servidores ODK",
      "projects": "Projetos",
      "users": "Usuários",
      "activeForms": "Formulários ativos",
      "defaultServer": "Servidor ODK padrão",
      "noDefaultServer": "Nenhum servidor padrão selecionado",
      "manageServers": "Gerir servidores ODK",
      "viewSync": "Abrir Sync Workbench",
      "loadError": "Falha ao carregar o resumo da infraestrutura"
    },
    "quickLinks": {
      "sectionTitle": "Páginas relacionadas",
      "userManagement": "Gestão de usuários",
      "statistics": "Estatísticas da organização",
      "projects": "Projetos",
      "odkServers": "Servidores ODK",
      "syncWorkbench": "Sincronização"
    }
  },
  "preferences": {
    "title": "Preferências",
    "subtitle": "Revise seu perfil de conta, acesso à organização, grupos de permissões e funções de projeto.",
    "accessOverview": "Visão geral de acesso",
    "organizationOwner": "Proprietário da organização",
    "organizationOwnerDescription": "Você tem acesso total a todos os recursos e projetos da organização.",
    "permissionGroups": "Grupos de permissões",
    "permissionGroupsDescription": "Grupos por projeto e suas funções",
    "perProject": "Por projeto",
    "noProjectGroups": "Nenhum grupo específico do projeto.",
    "projectsAccess": "Acesso a projetos",
    "projectsAccessDescription": "Projetos que você pode abrir e suas funções",
    "ownerNoProjects": "Como proprietário da organização, você tem acesso total. Os projetos aparecerão quando forem criados ou importados.",
    "noProjectAccess": "Nenhum acesso a projetos concedido ainda.",
    "projectIdLabel": "ID: {id}",
    "projectLabelFallback": "Projeto #{id}",
    "memberSince": "Membro desde:",
    "userFallback": "Usuário",
    "invalidDate": "Data inválida",
    "name": "Nome",
    "email": "E-mail",
    "password": "Senha",
    "resetPassword": "Redefinir senha",
    "emailSubscriptions": "Assinaturas por e-mail",
    "emailSubscriptionsVisit": "Para gerir os e-mails que recebe, visite as",
    "notificationSettingsLink": "Configurações de notificação",
    "cancelAccount": "Eliminar conta",
    "cancelAccountDescription": "Eliminar permanentemente a sua organização, utilizadores e todos os dados associados.",
    "cancelAccountAction": "Eliminar conta",
    "editName": "Editar nome",
    "editNameSubtitle": "Atualize o nome exibido na aplicação.",
    "nameRequired": "O nome é obrigatório",
    "nameMinLength": "O nome deve ter pelo menos 2 caracteres",
    "nameUpdateFailed": "Falha ao atualizar o nome. Tente novamente.",
    "nameChangedSuccess": "O seu nome foi alterado com sucesso",
    "resetPasswordTitle": "Redefinir senha",
    "resetPasswordSubtitle": "Digite sua senha atual e escolha uma nova.",
    "passwordRequirementsTitle": "Requisitos da senha",
    "currentPassword": "Senha atual",
    "newPassword": "Nova senha",
    "repeatNewPassword": "Repetir nova senha",
    "passwordMinLength": "Deve ter pelo menos 8 caracteres",
    "passwordUniqueChars": "Deve conter pelo menos 6 caracteres únicos",
    "updatePassword": "Atualizar senha",
    "passwordChangedSuccess": "A sua senha foi alterada com sucesso",
    "passwordUpdateFailed": "Falha ao atualizar a senha. Tente novamente.",
    "currentPasswordRequired": "O campo senha atual é obrigatório",
    "newPasswordRequired": "O campo nova senha é obrigatório",
    "repeatPasswordRequired": "O campo repetir senha é obrigatório",
    "passwordMatchUnique": "A nova senha não pode ser igual à atual",
    "confirmPasswordMismatch": "A confirmação não coincide com a nova senha",
    "dangerZoneTitle": "Zona de perigo",
    "dangerZoneSubtitle": "Ações irreversíveis que afetam toda a sua organização.",
    "cancelAccountModalTitle": "Eliminar conta",
    "cancelAccountModalSubtitle": "Verifique a sua identidade e confirme que deseja eliminar permanentemente a sua conta.",
    "cancelAccountConsequenceOrg": "A sua organização e todos os projetos serão eliminados",
    "cancelAccountConsequenceUsers": "Todos os membros da organização perderão o acesso",
    "cancelAccountConsequenceOdk": "Os dados ODK vinculados podem ser removidos permanentemente",
    "cancelAccountConsequenceIrreversible": "Esta ação não pode ser desfeita",
    "cancelAccountConfirmEmailLabel": "Digite o seu endereço de e-mail para confirmar",
    "cancelAccountConfirmEmailRequired": "A confirmação do e-mail é obrigatória",
    "cancelAccountConfirmEmailMismatch": "O e-mail não corresponde à sua conta",
    "cancelAccountAcknowledge": "Compreendo que isto eliminará permanentemente a minha organização e todos os dados associados",
    "cancelAccountAcknowledgeRequired": "Deve confirmar que compreende as consequências",
    "cancelAccountDeleteButton": "Eliminar conta permanentemente",
    "cancelAccountUnavailableTitle": "A eliminação de conta ainda não está disponível",
    "cancelAccountUnavailableMessage": "A sua identidade foi verificada. A eliminação de conta está a ser preparada — contacte o administrador ou o suporte para solicitar o encerramento da conta.",
    "cancelAccountWrongPassword": "Palavra-passe incorreta. Tente novamente.",
    "dangerZoneCancelAccount": "Zona de perigo: Eliminar conta",
    "cancelAccountWarning": "Isto eliminará permanentemente a sua conta e todos os dados associados, incluindo a sua organização, utilizadores e dados ODK vinculados.",
    "groupFallback": "Grupo"
  },
  "faq": {
    "title": "Ajuda",
    "subtitle": "Guias curtos e respostas para tarefas comuns do UDACAPI."
  },
  "settings": {
    "title": "Configurações",
    "subtitle": "Ajuste a aparência do aplicativo, o idioma e as preferências de notificação.",
    "themeSection": "Tema",
    "generalSection": "Preferências gerais",
    "notificationsNoticeTitle": "As configurações de notificação foram agrupadas e simplificadas",
    "notificationsNoticeBody": "As suas escolhas de configuração anteriores não foram alteradas."
  },
  "projects": {
    "pageTitle": "Projetos",
    "subtitle": "Gerencie seus projetos, mude entre cartões e tabelas, e inicie fluxos de importação ou criação.",
    "refresh": "Atualizar",
    "createProject": "Criar Projeto",
    "importRestrictions": {
      "message": "A importação de projetos é permitida apenas em servidores que pertençam à organização. Servidores Shared e Global não podem ser usados para importar projetos."
    },
    "viewMode": {
      "cards": "Cartões",
      "table": "Tabela"
    },
    "sections": {
      "forms": {
        "title": "Formulários do projeto"
      },
      "users": {
        "title": "Usuários do projeto"
      },
      "formAccess": {
        "title": "Acesso a formulários",
        "description": "Escolha quais App Users podem descarregar cada formulário no ODK Collect.",
        "save": "Guardar",
        "discard": "Descartar",
        "saving": "A guardar…",
        "saved": "Acesso a formulários guardado",
        "saveError": "Não foi possível guardar todas as alterações",
        "loadError": "Não foi possível carregar o acesso a formulários",
        "emptyForms": "Não há formulários publicados neste projeto",
        "emptyAppUsers": "Ainda não há App Users. Crie primeiro um código QR.",
        "openQr": "Abrir QR workbench",
        "openForms": "Abrir formulários",
        "dirtyHint": "Alterações não guardadas"
      },
      "info": {
        "title": "Informações do projeto",
        "basicInfo": "Informações básicas",
        "accessInfo": "Acesso",
        "statistics": "Estatísticas do projeto",
        "fields": {
          "projectId": "ID do projeto",
          "name": "Nome",
          "description": "Descrição",
          "status": "Estado",
          "orgId": "ID da organização",
          "odkProjectId": "ID do projeto ODK",
          "createdAt": "Data de criação",
          "updatedAt": "Última atualização",
          "yourRole": "Seu papel",
          "canManageForms": "Pode gerir formulários",
          "canViewUsers": "Pode ver usuários",
          "isManager": "É gerente",
          "isOwner": "É proprietário",
          "totalUsers": "Usuários do projeto"
        },
        "status": {
          "active": "Ativo",
          "archived": "Arquivado"
        },
        "noDescription": "Sem descrição",
        "loading": "Carregando informações do projeto...",
        "loadError": "Falha ao carregar informações do projeto",
        "statsLoadError": "Falha ao carregar estatísticas do projeto",
        "invalidDate": "Data inválida",
        "notAvailable": "N/D"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Adicionar usuário ao projeto",
        "editTitle": "Editar acesso ao projeto",
        "addSubtitle": "Primeiro selecione um usuário e depois atribua grupos de permissões para este projeto.",
        "editSubtitle": "Revise o usuário selecionado e atualize os grupos de permissões para este projeto.",
        "stepOne": "Passo 1",
        "stepTwo": "Passo 2",
        "stepReady": "Pronto",
        "stepRequired": "Obrigatório",
        "stepLocked": "Bloqueado",
        "selectUserTitle": "Selecionar usuário",
        "selectedUser": "Usuário selecionado",
        "selectUserHint": "Escolha quem deve receber acesso a este projeto.",
        "selectedUserHint": "Este usuário já está atribuído ao projeto. Você pode atualizar os grupos de permissões abaixo.",
        "selectUserPlaceholder": "Selecione um usuário",
        "selectUserHelper": "Proprietários e superusuários não aparecem nesta lista.",
        "permissionGroupsTitle": "Grupos de permissões",
        "permissionGroupsHint": "Selecione um ou mais grupos de permissões para o usuário selecionado.",
        "permissionGroupsLockedTitle": "Selecione um usuário para continuar",
        "permissionGroupsLockedHint": "Os grupos de permissões ficarão disponíveis depois que você escolher um usuário.",
        "addToProject": "Adicionar ao projeto",
        "clientUser": "Usuário cliente",
        "internalUser": "Usuário interno"
      },
      "dialogs": {
        "removeUser": {
          "title": "Remover usuário do projeto",
          "message": "Tem certeza de que deseja remover este usuário do projeto?",
          "confirm": "Remover"
        }
      },
      "list": {
        "searchPlaceholder": "Pesquisar usuários",
        "filterByPermissionGroups": "Filtrar por grupos de permissões",
        "accessDeniedTitle": "Acesso negado",
        "accessDeniedMessage": "Você não tem permissão para ver os usuários deste projeto.",
        "loadErrorTitle": "Não foi possível carregar os usuários do projeto",
        "emptyTitle": "Ainda não há usuários no projeto",
        "emptyMessage": "Adicione o primeiro usuário para começar a gerir o acesso ao projeto.",
        "emptyFilteredTitle": "Nenhum usuário corresponde aos filtros atuais",
        "emptyFilteredMessage": "Tente alterar a busca ou os grupos de permissões selecionados.",
        "noPermissionGroups": "Sem grupos de permissões"
      },
      "messages": {
        "saveSuccess": "O acesso do usuário foi atualizado com sucesso.",
        "removeSuccess": "O usuário foi removido do projeto."
      },
      "errors": {
        "assignGroupsFailed": "Falha ao atribuir grupos de permissões. Tente novamente.",
        "assignRoleFailed": "Falha ao atribuir a função do projeto.",
        "loadUsersFailed": "Falha ao carregar os usuários do projeto.",
        "permissionGroupsLoadFailed": "Falha ao carregar os grupos de permissões.",
        "projectMemberRoleFailed": "Falha ao resolver a função project member.",
        "removeUserFailed": "Falha ao remover o usuário do projeto.",
        "rolesLoadFailed": "Falha ao carregar as funções do projeto.",
        "saveUserFailed": "Falha ao atualizar o acesso ao projeto."
      }
    },
    "modal": {
      "addProject": "Adicionar projeto",
      "editProject": "Editar projeto",
      "unsavedChanges": "O formulário tem alterações não salvas. Tem certeza de que deseja fechá-lo?"
    },
    "form": {
      "projectName": {
        "label": "Nome do Projeto",
        "placeholder": "Digite o nome do projeto",
        "required": "O nome do projeto é obrigatório"
      },
      "odkServer": {
        "label": "Servidor ODK",
        "placeholder": "Selecionar servidor ODK",
        "required": "O servidor ODK é obrigatório",
        "noServers": "Nenhum servidor ODK disponível. Por favor, adicione um servidor primeiro."
      },
      "description": {
        "label": "Descrição",
        "placeholder": "Descrição opcional do projeto"
      },
      "buttons": {
        "cancel": "Cancelar"
      }
    },
    "cards": {
      "noProjects": "Nenhum projeto",
      "status": {
        "active": "Ativo",
        "archived": "Arquivado"
      }
    },
    "confirmations": {
      "odkServerRequired": "Por favor, adicione pelo menos um servidor ODK antes de criar um projeto.",
      "delete": {
        "imported": {
          "title": "Excluir projeto importado",
          "message": "Tem certeza de que deseja excluir o projeto \"{name}\"?\n\nEste projeto foi importado do ODK Central. Ele será excluído apenas do banco de dados desta aplicação, mas permanecerá no servidor ODK Central.",
          "messageWithStats": "Tem certeza de que deseja excluir o projeto \"{name}\"?\n\nEste projeto contém {formsCount} formulários e {submissionsCount} submissões.\nO projeto será arquivado/ocultado (soft-delete), e os dados serão preservados.\n\nEste projeto foi importado do ODK Central. Ele será excluído apenas do banco de dados desta aplicação, mas permanecerá no servidor ODK Central."
        },
        "regular": {
          "title": "Excluir projeto",
          "message": "Tem certeza de que deseja excluir o projeto \"{name}\"?\n\nAVISO: Isso excluirá permanentemente o projeto do banco de dados desta aplicação e do servidor ODK Central.",
          "messageWithStats": "Tem certeza de que deseja excluir o projeto \"{name}\"?\n\nEste projeto contém {formsCount} formulários e {submissionsCount} submissões.\nO projeto será arquivado/ocultado (soft-delete), e os dados serão preservados."
        },
        "confirmButton": "Excluir"
      }
    },
    "notifications": {
      "organizationNotSelected": "Organização não selecionada"
    },
    "import": {
      "title": "Importar Projetos ODK",
      "subtitle": "Carregue projetos ODK existentes do servidor da organização e importe-os neste espaço de trabalho.",
      "selectServer": "Selecionar Servidor ODK",
      "getProjects": "Obter Projetos",
      "availableProjects": "Projetos Disponíveis",
      "noProjectsFound": "Nenhum projeto encontrado no servidor selecionado.",
      "importProject": "Importar",
      "imported": "Importado",
      "errors": {
        "serversLoadFailed": "Falha ao carregar servidores ODK. Tente novamente mais tarde.",
        "projectsLoadFailed": "Falha ao carregar projetos do servidor ODK. Verifique a conexão e tente novamente.",
        "importFailed": "Falha ao importar projeto. Tente novamente mais tarde.",
        "importError": "Erro ao importar projeto: {detail}"
      }
    },
    "importForms": {
      "title": "Importar Formulários ODK",
      "subtitle": "Selecione formulários do seu projeto ODK Central para adicioná-los aqui.",
      "subtitleWithProject": "Selecione formulários do projeto Central {odkProjectId} para adicioná-los a {name}.",
      "loadingForms": "Carregando formulários do servidor ODK...",
      "availableForms": "Formulários Disponíveis",
      "searchForms": "Pesquisar formulários...",
      "selectAll": "Selecionar Tudo",
      "deselectAll": "Desmarcar Tudo",
      "importSelected": "Importar Selecionados",
      "noFormsFound": "Nenhum formulário encontrado para este projeto no servidor ODK.",
      "errors": {
        "projectNotLinked": "O projeto não está vinculado a um servidor ODK",
        "formsLoadFailed": "Falha ao carregar formulários do servidor ODK. Tente novamente mais tarde.",
        "formsLoadError": "Erro ao carregar formulários: {detail}",
        "importFailed": "Falha ao importar formulários. Tente novamente mais tarde.",
        "importError": "Erro de importação: {detail}"
      },
      "status": {
        "imported": "Importado",
        "available": "Disponível"
      },
      "progress": {
        "started": "Importação iniciada",
        "completedSummary": "Os formulários estão prontos neste projeto.",
        "failedSummary": "Alguns formulários não puderam ser importados. Consulte os detalhes abaixo.",
        "viewProject": "Ver projeto",
        "forms": "{done} / {total} formulários",
        "submissions": "{count} submissões processadas",
        "submissionsProgress": "{fetched} / {total} submissões sincronizadas",
        "stages": {
          "queued": "A aguardar início",
          "pending": "A aguardar início",
          "importingForms": "A importar formulários",
          "syncingData": "A sincronizar dados"
        },
        "messages": {
          "queued": "A tarefa foi coloa cada na fila e aguarda início...",
          "importingForms": "A importar metadados de formulários..."
        }
      }
    },
    "detail": {
      "loading": "Carregando projeto...",
      "returnToProjects": "Voltar aos projetos",
      "forms": {
        "title": "Formulários do projeto",
        "noForms": "O projeto não possui formulários.",
        "contactAdmin": "Entre em contato com o administrador para adicionar formulários.",
        "actions": {
          "publish": "Publicar",
          "abandon": "Abandonar",
          "attachments": "Anexos",
          "qrCode": "Código QR para testes",
          "previewEnketo": "Visualizar no Enketo",
          "downloadTestData": "Baixar dados de teste",
          "formSettings": "Configurações do formulário",
          "viewDetails": "Ver/Detalhes",
          "changeState": "Alterar estado",
          "delete": "Excluir/Abandonar"
        },
        "modals": {
          "qrCode": {
            "title": "Código QR para testes",
            "description": "Escaneie o código QR para testar o formulário"
          },
          "formSettings": {
            "title": "Configurações do formulário",
            "basicSettings": "Configurações básicas (Placeholder)",
            "accessSettings": "Configurações de acesso (Placeholder)",
            "placeholder": "Esta é uma interface de demonstração. A funcionalidade está em desenvolvimento."
          }
        },
        "messages": {
          "tryAgain": "Tentar novamente",
          "publishing": "Publicando formulário {name}...",
          "published": "Formulário {name} publicado com sucesso",
          "previewing": "Visualizando {name} no Enketo (dev placeholder)",
          "downloading": "Baixando dados de teste para {name} (dev placeholder)",
          "saving": "Salvando configurações para {name} (dev placeholder)",
          "missingData": "Dados ausentes para importar formulários",
          "missingXlsformData": "Dados ausentes para carregar XLSForm",
          "noAttachments": "O formulário não tem anexos"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "Servidores ODK",
    "subtitle": "Gerencie os servidores ODK da organização, suas configurações, visibilidadee e estado de conexão.",
    "addServer": "Adicionar servidor",
    "editServer": "Editar servidor",
    "deleteServer": "Excluir servidor",
    "modal": {
      "addSubtitle": "Conecte um servidor ODK Central a esta organização.",
      "editSubtitle": "Atualize as configurações de conexão do servidor."
    },
    "table": {
      "default": "Padrão",
      "visibility": "Visibilidadee",
      "setAsDefault": "Definir como padrão",
      "setAsDefaultTooltip": "Definir como servidor padrão para esta organização",
      "testConnection": "Testar conexão",
      "testConnectionTooltip": "Testar conexão com o servidor ODK Central",
      "testConnectionDisabled": "O teste de conexão está disponível apenas para servidores pertencentes à organização",
      "editServer": "Editar servidor",
      "editServerTooltip": "Editar detalhes do servidor (apenas para servidores ORGANIZAÇÃO e com permissões)",
      "deleteServer": "Excluir servidor",
      "deleteServerTooltip": "Excluir servidor (apenas para servidores ORGANIZAÇÃO e com permissões)",
      "odkSession": "Sessão ODK"
    },
    "session": {
      "banner": "Um ou mais servidores têm uma sessão ODK Central a expirar ou inválida, ou não há palavra-passe guardada. Edite o servidor e guarde a palavra-passe para a aplicação voltar a ligar automaticamente.",
      "ok": "Sessão OK",
      "expiresSoon": "Expira em breve",
      "expired": "Expirada",
      "unknown": "Desconhecido",
      "noStoredPassword": "Sem palavra-passe guardada"
    },
    "form": {
      "serverName": "Nome do servidor",
      "serverUrl": "URL do servidor",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Nome de usuário",
      "password": "Senha",
      "passwordPlaceholderEdit": "Deixar vazio para não alterar",
      "description": "Descrição",
      "serverIsActive": "Servidor ativo",
      "serverIsActiveHint": "Servidores inativos permanecem na lista, mas não são oferecidos ao criar projetos."
    },
    "validation": {
      "serverNameRequired": "O nome do servidor é obrigatório",
      "serverUrlRequired": "A URL do servidor é obrigatória",
      "urlFormatInvalid": "A URL deve começar com http:// ou https://",
      "usernameRequired": "O nome de usuário é obrigatório",
      "passwordRequired": "A senha é obrigatória"
    },
    "messages": {
      "selectOrganizationFirst": "Por favor, selecione ou crie uma organização primeiro",
      "loadingServers": "Carregando servidores...",
      "noServersFound": "Nenhum servidor ODK encontrado para esta organização",
      "failedToLoadServers": "Falha ao carregar servidores",
      "noServers": "Nenhum servidor ODK",
      "serverSaved": "Servidor \"{name}\" {action} com sucesso!",
      "serverSetAsDefault": "Servidor \"{name}\" definido como padrão",
      "connectionTestSuccess": "Ligação OK. Projetos encontrados: {count}",
      "connectionTestFailed": "Teste de conexão falhou"
    },
    "contextHint": "Conecte seu servidor ODK antes de sincronizar ou importar formulários."
  },
  "notifications": {
    "all": "Ver todas as notificações",
    "less": "Ver menos notificações"
  },
  "language": {
    "label": "Idioma",
    "english": "Inglês",
    "spanish": "Espanhol",
    "french": "Francês",
    "swahili": "Suaíli",
    "portuguese": "Português",
    "ukrainian": "Ucraniano",
    "russian": "Russo",
    "turkish": "Turco"
  },
  "auth": {
    "createAccount": "Criar conta",
    "dontHaveAccount": "Não tem uma conta?",
    "email": "Email",
    "emailInvalid": "O email deve ser válido",
    "emailRequired": "O campo de email é obrigatório",
    "enterEmail": "Digite seu email",
    "enterVerificationCode": "Por favor, insira o código de verificação",
    "forgotPassword": "Esqueceu sua senha?",
    "forgotPasswordDescription": "Se você esqueceu sua senha, não se preocupe. Simplesmente digite seu endereço de email abaixo, e nós enviaremos um email com instruções para redefinir sua senha. Restaurar o acesso à sua conta nunca foi tão fácil.",
    "fullName": "Nome completo",
    "fullNameRequired": "O campo de nome completo é obrigatório",
    "goBack": "Voltar",
    "haveAccount": "Já tem uma conta?",
    "login": "Entrar",
    "password": "Senha",
    "passwordMustContainLetter": "A senha deve conter pelo menos uma letra",
    "passwordMustContainNumber": "A senha deve conter pelo menos um número",
    "passwordMustContainSpecial": "A senha deve conter pelo menos um caractere especial",
    "passwordMustBe8Chars": "A senha deve ter pelo menos 8 caracteres",
    "passwordRequired": "O campo de senha é obrigatório",
    "passwordRequirements": "A senha deve ter 8+ caracteres: letras, números e caracteres especiais.",
    "passwordsDontMatch": "As senhas não coincidem",
    "registrationFailed": "O registro falhou. Por favor, tente novamente.",
    "registrationSuccess": "Você se registrou com sucesso! Por favor, verifique seu email para as instruções de ativação.",
    "repeatPassword": "Repetir senha",
    "repeatPasswordRequired": "O campo de repetir senha é obrigatório",
    "resetInstructionsSent": "As instruções de redefinição de senha foram enviadas para seu email.",
    "resetInstructionsFailed": "Não foi possível enviar o email de redefinição de senha. Por favor, tente novamente.",
    "resetPassword": "Redefinir senha",
    "sendResetInstructions": "Enviar instruções de redefinição",
    "signUp": "Cadastrar",
    "twoFactorAuthentication": "Autenticação de dois fatores",
    "verificationCode": "Código de verificação",
    "verificationCodeRequired": "O código de verificação é obrigatório",
    "verifyCode": "Verificar código"
  },
  "dashboard": {
    "subtitle": "Página de início com visualizações estatísticas e informações importantes.",
    "activeFormsTitle": "Formulários Ativos",
    "activeFormsSubtitle": "Número e estado dos formulários ativos.",
    "noActiveForms": "Nenhum formulário ativo"
  },
  "qr": {
    "title": "Código QR (definições ODK Collect)",
    "titleShort": "Código QR",
    "qrName": "Nome do código QR",
    "projectSection": "Projeto",
    "projectName": "Nome do projeto",
    "projectIcon": "Ícone do projeto",
    "projectColor": "Cor do projeto",
    "generalSection": "Definições gerais",
    "serverUrl": "URL do servidor",
    "username": "Nome de utilizador",
    "password": "Palavra-passe",
    "adminSection": "Definições de administrador",
    "admin": {
      "edit_saved": "Editar guardado",
      "send_finalized": "Enviar finalizado",
      "view_sent": "Ver enviado",
      "password": "Palavra-passe de administrador",
      "advanced": "Administrador avançado",
      "getBlank": "Obter em branco",
      "deleteSaved": "Eliminar guardado",
      "qrCodeScanner": "Scanner de código QR",
      "changeServer": "Mudar servidor",
      "changeAppTheme": "Mudar tema da app",
      "changeAppLanguage": "Mudar idioma da app",
      "changeFontSize": "Mudar tamanho da fonte",
      "changeNavigation": "Mudar navegação",
      "maps": "Mapas",
      "periodicUpdates": "Atualizações periódicas",
      "automaticUpdate": "Atualização automática",
      "hideOldVersions": "Ocultar versões antigas",
      "changeAutosend": "Mudar envio automático",
      "deleteAfterSend": "Eliminar após enviar",
      "defaultToFinalized": "Finalizado por defeito",
      "changeConstraintBehavior": "Mudar comportamento das restrições",
      "highResolution": "Alta resolução",
      "imageSize": "Tamanho da imagem",
      "guidanceHint": "Sugestão de orientação",
      "externalAppRecording": "Gravação com app externa",
      "instanceFormSync": "Sincronização de instâncias do formulário",
      "changeFormMetadata": "Mudar metadados do formulário",
      "analytics": "Análise",
      "movingBackwards": "Retroceder",
      "accessSettings": "Aceder às definições",
      "changeLanguage": "Mudar idioma",
      "jumpTo": "Ir para",
      "saveMid": "Guardar intermédio",
      "saveAs": "Guardar como",
      "markAsFinalized": "Marcar como finalizado"
    },
    "actions": {
      "generate": "Gerar QR",
      "downloadPng": "Transferir PNG",
      "copyBase64": "Copiar Base64",
      "reset": "Repor",
      "importJson": "Importar JSON"
    },
    "placeholder": "Gere o código QR para o ver aqui",
    "note": "O código contém Base64 comprimido com zlib de JSON com general/admin/project. A autenticação App User está em server_url.",
    "general": {
      "theme": "Tema",
      "language": "Idioma",
      "fontSize": "Tamanho da fonte",
      "navigation": "Navegação",
      "constraintBehavior": "Comportamento das restrições",
      "advanced": "Geral avançado",
      "formlistUrl": "URL da lista de formulários",
      "submissionUrl": "URL de submissão",
      "periodicUpdates": "Atualizações periódicas",
      "deleteAfterSend": "Eliminar após enviar",
      "defaultCompleted": "Concluído por defeito",
      "externalAppRecording": "Gravação com app externa"
    },
    "formManagement": {
      "title": "Gestão de formulários",
      "updateMode": "Modo de atualização",
      "autosend": "Envio automático",
      "imageSize": "Tamanho da imagem",
      "automaticUpdate": "Atualização automática",
      "hideOldVersions": "Ocultar versões antigas",
      "instanceSync": "Sincronização de instâncias",
      "guidanceHint": "Sugestão de orientação",
      "highResolution": "Alta resolução"
    },
    "maps": {
      "title": "Mapas",
      "basemap": "Mapa base",
      "googleStyle": "Estilo Google",
      "mapboxStyle": "Estilo Mapbox",
      "usgsStyle": "Estilo USGS",
      "cartoStyle": "Estilo CARTO",
      "referenceLayer": "Camada de referência (caminho)"
    },
    "identity": {
      "title": "Identidade",
      "analytics": "Análise",
      "userName": "Nome de utilizador",
      "email": "Correio eletrónico",
      "phone": "Telefone"
    },
    "presets": {
      "title": "Predefinições QR",
      "save": "Guardar predefinição",
      "load": "Carregar predefinição...",
      "delete": "Eliminar",
      "defaultName": "Predefinição {number}"
    },
    "preview": {
      "title": "Pré-visualização JSON",
      "reset": "Repor",
      "import": "Importar"
    },
    "history": {
      "title": "Códigos QR gerados",
      "viewAll": "Ver tudo",
      "view": "Ver",
      "download": "Transferir",
      "copy": "Copiar",
      "delete": "Eliminar",
      "more": "... e mais {count}"
    },
    "placeholders": {
      "qrName": "QR do meu dispositivo",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "icon": "📋",
      "projectName": "Equipa de campo"
    },
    "options": {
      "default": "Por defeito",
      "system": "Sistema"
    },
    "messages": {
      "nameRequiredForPreset": "Introduza um nome para a predefinição",
      "nameRequiredForAppUser": "O nome do código QR é obrigatório para criar o utilizador da app",
      "invalidSettings": "Definições inválidas",
      "generateError": "Falha ao gerar o QR e criar o utilizador da app",
      "invalidJsonStructure": "Estrutura JSON inválida. Deve conter as secções project, general e admin.",
      "invalidJsonFormat": "Formato JSON inválido",
      "copyBase64Error": "Falha ao copiar Base64",
      "projectNameRequired": "O nome do projeto é obrigatório",
      "serverRequired": "O URL do servidor é obrigatório",
      "missingOdkProject": "Este projeto não tem id de projeto ODK Central. Reimporte ou verifique as definições.",
      "generateSuccess": "QR gerado e App User criado",
      "presetSaved": "Predefinição guardada",
      "base64Copied": "Base64 copiado",
      "jsonImported": "Definições importadas do JSON"
    },
    "workbench": {
      "contextHint": "Crie um QR do ODK Collect com o token de App User no URL do servidor.",
      "serverReady": "Servidor definido",
      "essentialsTitle": "Configurar",
      "essentialsDesc": "Nomeie o QR e o cartão Collect, escolha ícone e cor, depois gere.",
      "nameHint": "Também usado como nome de apresentação do App User no ODK Central.",
      "serverHint": "Obtido do servidor ODK ligado ao projeto. Ao gerar é injetado /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Opções avançadas do Collect",
      "advancedHint": "Tema, sync de formulários, mapas — opcional",
      "previewTitle": "Pré-visualização",
      "previewDesc": "Digitalize com o ODK Collect após gerar.",
      "libraryHint": "Guardado neste browser para este projeto.",
      "libraryEmpty": "Ainda sem códigos QR. Gere um para começar.",
      "libraryCount": "{count} na biblioteca",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: não ligado — verifique o servidor ODK do projeto",
      "projectNameHint": "Rótulo no ODK Collect para esta configuração (não o nome do projeto udacapi).",
      "iconHint": "Mostrado no cartão do projeto no Collect. O predefinido basta na maioria dos casos.",
      "changeIcon": "Alterar ícone",
      "iconDialogTitle": "Ícone do projeto Collect",
      "iconDialogSubtitle": "Escolha um glifo para o cartão do projeto no dispositivo.",
      "applyIcon": "Usar ícone"
    },
    "formAccess": {
      "title": "Formulários a que este recolector pode aceder",
      "hint": "Selecione pelo menos um formulário publicado. Sem isso, o Collect mostra uma lista vazia.",
      "selectAll": "Selecionar tudo",
      "clear": "Limpar",
      "required": "Selecione pelo menos um formulário",
      "assignFailed": "Não foi possível atribuir formulários ao App User",
      "manageAll": "Gerir todo o acesso a formulários",
      "formsCount": "{n} formulários",
      "noPublishedForms": "Ainda não há formulários publicados neste projeto."
    }
  },
  "forms": {
    "state": {
      "open": "Aberto",
      "closing": "Fechando",
      "closed": "Fechado",
      "draft": "Rascunho"
    },
    "deleteConfirm": {
      "title": "Excluir formulário",
      "subtitle": "Revise as consequências antes de excluir permanentemente este formulário.",
      "message": "Esta ação não pode ser desfeita.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Excluir permanentemente",
      "importedWarning": "Este formulário foi importado do ODK Central. Será excluído apenas do banco de dados desta aplicação e permanecerá no servidor ODK Central.",
      "regularWarning": "Esta ação move o formulário para a lixeira ODK Central e marca como excluído localmente.",
      "consequenceDataLoss": "Todas as submissões e o histórico de exportação deste formulário serão removidos desta aplicação.",
      "irreversible": "Esta ação não pode ser revertida através da interface.",
      "success": "Formulário {name} excluído.",
      "successImported": "Formulário {name} excluído apenas do banco de dados desta aplicação.",
      "error": "Erro ao excluir formulário: {error}"
    },
    "uploadXlsform": {
      "title": "Carregar XLSForm",
      "subtitle": "Selecione uma planilha (.xlsx ou .xls, até 50 MB) para criar ou atualizar um formulário.",
      "selectFile": "Selecionar arquivo XLSForm",
      "dropFileTitle": "Solte sua planilha XLSForm aqui",
      "supportedFormats": "Formatos aceitos: .xlsx e .xls, até 50 MB.",
      "replaceFileHint": "Escolha outro arquivo para substituir a seleção atual.",
      "chooseFile": "Procurar arquivos",
      "selectedFile": "Arquivo selecionado:",
      "formSettings": "Identificador do formulário",
      "uploadOptions": "Opções de upload",
      "formId": "ID do formulário",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "ID do formulário único (apenas letras, números e underscores)",
      "formIdWarning": {
        "title": "Importante!",
        "message": "O ID do formulário será extraído automaticamente do arquivo XLSForm ('settings' planilha). Este campo é usado apenas como fallback."
      },
      "updateExisting": "Atualizar formulário existente",
      "updateExistingHint": "Se um formulário com este ID já existir, ele será atualizado",
      "ignoreWarnings": "Ignorar avisos",
      "ignoreWarningsHint": "Ignorar avisos durante a conversão",
      "publishImmediately": "Publicar formulário imediatamente",
      "publishImmediatelyHint": "Publicar o formulário imediatamente",
      "uploadButton": "Carregar XLSForm",
      "uploading": "Carregando...",
      "noFileSelected": "Por favor, selecione um arquivo para carregar",
      "noFormId": "Por favor, insira o ID do formulário",
      "uploadingMessage": "Carregando XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" carregado com sucesso!",
      "errorMessage": "Erro ao carregar: {error}",
      "errorFallback": "Falha no upload. Tente novamente.",
      "listUpdated": "XLSForm carregado com sucesso! Lista atualizada."
    },
    "formDetail": {
      "loading": "Carregando formulário...",
      "formLabel": "Formulário",
      "returnToProjects": "Voltar à lista de projetos",
      "sectionShell": {
        "unknownForm": "Formulário desconhecido",
        "loading": "Carregando...",
        "retry": "Repetir",
        "comingSoonTitle": "Bem em breve",
        "comingSoonDescription": "Esta funcionalidade está em desenvolvimento. Use outras ferramentas de formulário enquanto isso."
      },
      "sections": {
        "dashboard": {
          "title": "Visão Geral do Formulário",
          "description": "Estatísticas e informações sobre o formulário e dados coletados"
        },
        "qc": {
          "title": "Controle de Qualidade",
          "description": "Monitorar e validar a qualidade dos dados usando regras QC",
          "workbench": {
            "contextHint": "Defina regras, valide submissões e reveja problemas assinalados para este formulário.",
            "rulesCount": "{count} regras",
            "activeCount": "{count} ativas",
            "validationsCount": "{count} validações",
            "summaryTitle": "Visão geral de regras",
            "selectedCount": "{count} seleccionadas",
            "createRuleHint": "Definir uma nova regra de validação para este formulário",
            "editRuleHint": "Atualizar configurações e expressão da regra",
            "backToRules": "Voltar às regras",
            "pipeline": {
              "ariaLabel": "Flujo de trabajo de validação QC",
              "define": "Definir regras",
              "defineHint": "{count} regras configuradas",
              "defineEmpty": "Sem regras aún: cree su primera verificación",
              "validate": "Validar dados",
              "validateHint": "{count} submissões verificados",
              "validateEmpty": "Ejecute validação en os submissões entrantes",
              "review": "Rever problemas",
              "reviewHint": "{count} problemas em aberto",
              "reviewClear": "Sem problemas por resolver"
            }
          }
        },
        "dataExport": {
          "title": "Exportação de Dados",
          "description": "Exportar dados do formulário em vários formatos"
        },
        "odkExport": {
          "title": "Exportação de dados",
          "description": "Exportar dados do formulário em vários formatos para análise",
          "unknownForm": "Formulário desconhecido",
          "exportsCount": "{count} exportações",
          "loadingOptions": "Carregando opções de exportação...",
          "retry": "Repetir",
          "infoSubtitleDetailed": "Selecione os formatos de exportação e configure as opções para baixar os dados do seu formulário.",
          "formatsAvailable": "{count} formatos disponíveis",
          "formatsTitle": "Formatos de exportação",
          "selectFormats": "Selecione um ou mais formatos para exportar",
          "statisticalFormatsTitle": "Formatos estatísticos",
          "geoFormatsTitle": "Formatos geográficos",
          "noGeoData": "Nenhum dado geográfico encontrado neste formulário",
          "configTitle": "Configuração de exportação",
          "configSubtitle": "Configure as opções de exportação e filtros",
          "dataOptions": "Opções de dados",
          "includeRepeats": "Incluir grupos repetidos",
          "includeLabels": "Incluir etiquetas de campo",
          "includeMetadata": "Incluir metadados",
          "labelLanguage": "Idioma da etiqueta",
          "selectLanguage": "Selecionar idioma",
          "loadingLanguages": "Carregando idiomas...",
          "generatingLabels": "Gerando etiquetas...",
          "noLabelsAvailable": "Nenhuma etiqueta disponível. Clique em atualizar para gerar etiquetas.",
          "filters": "Filtros",
          "dateRange": "Intervalo de datas",
          "startDate": "Data de início",
          "endDate": "Data de término",
          "dataFilter": "Filtro de dados",
          "dataFilterPlaceholder": "ex: idade > 18",
          "readyToExport": "Pronto para exportar",
          "readyToExportSubtitle": "Clique no botão para iniciar o processo de exportação",
          "labelsRequiredNotice": "As etiquetas são necessárias, mas não estão disponíveis. Por favor, gere etiquetas primeiro.",
          "activeExports": "Exportações ativas",
          "exportButton": "Exportar dados",
          "historyTitle": "Histórico de exportações",
          "historySubtitle": "Ver e baixar exportações anteriores",
          "refresh": "Atualizar",
          "loadingHistory": "Carregando histórico...",
          "noHistory": "Ainda não há exportações",
          "noHistoryDesc": "Comece exportando os dados no seu formato preferido.",
          "workbench": {
            "contextHint": "Selecione formatos e opções, em seguida, execute a exportação.",
            "geoAvailable": "Dados geográficos",
            "geoUnavailable": "Nenhum dado geográfico",
            "optionsTitle": "Opções",
            "refreshLabels": "Atualizar etiquetas",
            "labelsGenerated": "Etiquetas geradas ({count} idiomas)",
            "exportButtonOne": "Exportar 1 formato",
            "exportButtonMany": "Exportar {count} formatos",
            "selectFormatHint": "Selecione pelo menos um formato para exportar.",
            "readySummaryOne": "1 formato pronto para exportar.",
            "readySummaryMany": "{count} formatos prontos para exportar.",
            "jobsTitle": "Trabalhos",
            "jobsSubtitle": "Acompanhe exportações ativas e baixe arquivos anteriores.",
            "noActiveJobs": "Nenhuma exportação ativa.",
            "noHistoryAction": "Selecione um formato acima e execute a exportação.",
            "pipeline": {
              "sync": "Sincronizar dados",
              "convert": "Converter",
              "ready": "Pronto"
            }
          },
          "date": "Data",
          "format": "Formato",
          "records": "Registos",
          "size": "Tamanho",
          "user": "Usuário",
          "actions": "Ações",
          "download": "Baixar",
          "viewError": "Ver erro",
          "errorDetails": "Detalhes do erro",
          "errorSubtitle": "Informação do erro de execução de exportação",
          "close": "Fechar",
          "deleteTitle": "Excluir exportação",
          "deleteSubtitle": "Esta ação não pode ser desfeita",
          "deleteConfirm": "Tem certeza de que deseja excluir a exportação de {date}? Esta ação não pode ser desfeita.",
          "cancel": "Cancelar",
          "delete": "Excluir",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Todos os dados",
            "last30": "Últimos 30 dias",
            "last90": "Últimos 90 dias",
            "thisyear": "Este ano",
            "lastyear": "Ano passado",
            "custom": "Intervalo personalizado"
          },
          "status": {
            "odataSyncError": "Erro de verificação de sincronização OData: {error}",
            "localDataMissing": "Dados locais ausentes, baixando OData...",
            "odataStatusError": "Erro de status OData",
            "downloadingOdata": "Baixando OData...",
            "downloadSuccessCount": "{count} submissões baixadas",
            "downloadError": "Erro de download OData: {error}",
            "geoRequired": "{format} requer dados geográficos"
          },
          "notifications": {
            "selectFormat": "Por favor, selecione pelo menos um formato",
            "startingDownload": "Iniciando download...",
            "downloadSuccess": "Arquivo baixado com sucesso",
            "downloadError": "Erro de download: {error}",
            "taskIdMissing": "Não é possível baixar: ID de tarefa ausente",
            "exportDeleted": "Exportação excluída com sucesso",
            "exportCompleted": "Exportação {format} concluída",
            "exportFailed": "Exportação {format} falhou",
            "trackingError": "Erro de rastreamento: {error}",
            "noErrorDetails": "Nenhum detalhe de erro disponível",
            "currentUser": "Usuário atual"
          }
        },
        "dataAnalysis": {
          "title": "Análise de Dados",
          "description": "Construir tabelas pivot para análise ad-hoc e salvar visualizações para monitoramento",
          "recordsLoaded": "{count} registos carregados",
          "variablesSelected": "{count} variáveis selecionadas",
          "tablesAvailable": "{count} tabelas disponíveis",
          "workbench": {
            "contextHint": "Selecione variáveis, explore com uma tabela pivot, então salve uma visualização para monitoramento",
            "loadingData": "Carregando dados...",
            "pipeline": {
              "ariaLabel": "Fluxo de análise",
              "source": "Fonte de dados",
              "sourceHint": "{table}",
              "sourceEmpty": "Escolha uma tabela de dados",
              "variables": "Variáveis",
              "variablesHint": "{count} selecionadas",
              "variablesEmpty": "Escolha campos para analisar",
              "pivot": "Tabela pivot",
              "pivotHint": "{count} registos carregados",
              "pivotEmpty": "Carregue dados para explorar",
              "pivotLoading": "Carregando registos...",
              "save": "Salvar visualização",
              "saveHint": "Pronto para salvar no monitoramento",
              "saveEmpty": "Configure uma tabela pivot primeiro"
            },
            "source": {
              "title": "Fonte de dados",
              "subtitle": "Escolha qual tabela de submissão e como os valores são exibidos",
              "labelsMissing": "Etiquetas não geradas para este formulário",
              "labelsMissingHint": "Gere etiquetas a partir do XLSForm para mostrar nomês de variáveis e etiquetas de valores.",
              "generateLabels": "Gerar etiquetas",
              "table": "Tabela de dados",
              "tablePlaceholder": "Escolha uma tabela de dados",
              "displayOptions": "Opções de exibição",
              "showLabels": "Mostrar etiquetas",
              "language": "Idioma",
              "includeMetadata": "Incluir metadados"
            },
            "variables": {
              "title": "Variáveis",
              "selectedCount": "{count} selecionadas",
              "selectTableFirst": "Selecione uma tabela de dados para ver as variáveis disponíveis.",
              "selectAll": "Selecionar todos",
              "clearAll": "Limpar todos",
              "searchPlaceholder": "Pesquisar variáveis...",
              "empty": "Nenhuma variável corresponde à sua pesquisa",
              "moreCount": "+{count} mais",
              "loading": "Carregando...",
              "loadCta": "Carregar {count} variáveis"
            },
            "pivot": {
              "title": "Tabela pivot",
              "subtitle": "Arraste campos para linhas, colunas ou valores para construir sua visualização",
              "hint": "Arraste variáveis para linhas, colunas ou valores. Quando o layout estiver certo, salve como uma tabela de monitoramento.",
              "reprocess": "Reprocessar análises",
              "saveCta": "Salvar no monitoramento",
              "analyticsProcessed": "{percent}% processado"
            },
            "empty": {
              "title": "Selecione variáveis",
              "hint": "Escolha uma ou mais variáveis da tabela selecionada para começar sua análise."
            },
            "save": {
              "title": "Salvar tabela de monitoramento",
              "subtitle": "Dê um nome a esta visualização pivot para que você possa encontrá-la na página de monitoramento.",
              "tableName": "Nome da tabela",
              "tableNamePlaceholder": "Digite o nome da tabela",
              "description": "Descrição",
              "descriptionPlaceholder": "O que esta tabela rastreia?",
              "summary": "Resumo da análise",
              "variables": "Variáveis",
              "table": "Tabela",
              "cancel": "Cancelar",
              "confirm": "Salvar tabela"
            },
            "toasts": {
              "labelsGenerated": "Etiquetas geradas. Recarregando variáveis...",
              "labelsFailed": "Não foi possível gerar etiquetas. Verifique se o XLSForm está disponível.",
              "saveSuccess": "Tabela salva. Abra Data Monitoring para visualizá-la.",
              "saveFailed": "Não foi possível salvar a tabela. Tente novamente ou contate o suporte.",
              "formIdMissing": "Form ID não encontrado",
              "reprocessSuccess": "Análises reprocessadas: {count} novos registos",
              "reprocessFailed": "Análises reprocessadas falhou",
              "reprocessError": "Erro de reprocessamento de análises: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Monitoramento de Dados",
          "description": "Visualize tabelas de monitoramento salvas com atualizações em tempo real",
          "tablesCount": "{count} tabelas",
          "updating": "Atualizando...",
          "workbench": {
            "contextHint": "Visualizações pivot salvas com atualização de dados em tempo real enquanto esta página está aberta",
            "activeViewsCount": "{count} ativas",
            "liveStrip": {
              "ariaLabel": "Status de monitoramento",
              "saved": "Tabelas salvas",
              "savedHint": "{count} tabelas prontas",
              "savedEmpty": "Nenhuma tabela salva ainda",
              "watch": "Visualização ativa",
              "watchHint": "Visualizando {title}",
              "watchEmpty": "Selecione uma tabela para visualizar",
              "watchDisabled": "Crie uma tabela primeiro",
              "sync": "Sincronização em tempo real",
              "syncHint": "Atualizações a a cada 30 segundos",
              "syncActive": "Atualizando agora..."
            },
            "displayOptions": {
              "title": "Opções de exibição",
              "subtitle": "Controle como os nomês de variáveis aparecem nas tabelas pivot",
              "showLabels": "Mostrar etiquetas",
              "language": "Idioma"
            },
            "summary": {
              "title": "Em um olhar",
              "tables": "Tabelas salvas",
              "activeView": "Visualização ativa",
              "records": "Registos na visualização",
              "refreshInterval": "Atualização automática"
            },
            "tables": {
              "title": "Tabelas de monitoramento",
              "subtitle": "Visualizações pivot salvas a partir da análise de dados",
              "loading": "Carregando tabelas de monitoramento...",
              "emptyTitle": "Nenhuma tabela de monitoramento ainda",
              "emptyHint": "Crie uma tabela pivot na página de análise e salve aqui.",
              "createCta": "Ir para análise",
              "realtimeHint": "Os dados são atualizados a a cada 30 segundos enquanto esta página está aberta. Use Atualizar para uma atualização imediata.",
              "records": "{count} registos",
              "lastUpdated": "Última atualização {time}",
              "view": "Visualizar",
              "hide": "Ocultar",
              "loadingPivot": "Carregando dados pivot...",
              "public": "Público",
              "private": "Privado"
            },
            "delete": {
              "title": "Excluir tabela",
              "confirm": "Excluir tabela \"{title}\"?",
              "detail": "Esta ação remove permanentemente a tabela e seus dados em cache.",
              "cancel": "Cancelar",
              "confirmBtn": "Excluir tabela"
            }
          }
        },
        "settings": {
          "title": "Configurações",
          "description": "Gerenciamento de configurações do formulário",
          "formStatus": "Status do Formulário",
          "basicSettings": "Configurações Básicas",
          "notifications": {
            "noChanges": "Nenhuma alteração para salvar",
            "draftWarning": "Rascunhos de formulários não podem ser alterados através desta interface. Primeiro publique o formulário.",
            "stateChangeHint": "Alterar o status do formulário afeta se novos envios são aceitos.",
            "invalidState": "Status de formulário inválido: {state}",
            "success": "Status do formulário alterado com sucesso para {state}",
            "error": "Erro ao alterar o status do formulário: {error}",
            "errorLog": "Erro ao alterar o status do formulário"
          },
          "version": {
            "title": "Versão",
            "notSpecified": "Não especificada",
            "history": "Histórico de Versões",
            "noHistory": "Nenhum histórico de versões disponível",
            "download": "Baixar",
            "restore": "Restaurar",
            "uploadNew": "Carregar Nova Versão",
            "author": "Autor"
          },
          "dataCollectors": {
            "title": "Coletores de Dados",
            "description": "Gerir o acesso dos usuários à coleta de dados do formulário",
            "noCollectors": "Nenhum coletor de dados atribuído",
            "addCollector": "Adicionar Coletor",
            "editCollector": "Editar Coletor",
            "removeCollector": "Remover Coletor",
            "addCollectorModal": {
              "title": "Adicionar Coletor de Dados",
              "placeholder": "Stub: aqui estará o formulário para adicionar coletor de dados"
            }
          },
          "publicAccess": {
            "title": "Acesso Público",
            "description": "Criar um link público para coleta de dados através da interface web",
            "publicLink": "Link Público",
            "disable": "Desabilitar",
            "requireAuth": "Exigir autenticação",
            "collectEmail": "Coletar email",
            "limitSubmissions": "Limitar número de respostas",
            "maxSubmissions": "Número máximo de respostas",
            "updateSettings": "Atualizar Configurações",
            "createLink": "Criar Link Público",
            "notCreated": "Link público não criado. Crie um link para coleta de dados através da interface web.",
            "created": "Link público criado",
            "copied": "Link copiado para a área de transferência",
            "disabled": "Link público desabilitado",
            "updated": "Configurações do link público atualizadas"
          },
          "qrCodes": {
            "title": "Códigos QR para coleta de dados",
            "description": "Gerir códigos QR para configurar dispositivos de coleta de dados para este formulário",
            "assignedTitle": "Códigos QR atribuídos",
            "availableTitle": "Códigos QR do projeto disponíveis",
            "createNew": "Criar novo código QR",
            "noAvailable": "Nenhum código QR disponível",
            "createInstruction": "Crie um código QR para configurar dispositivos de coleta de dados",
            "manageOnProject": "Os códigos QR do ODK Collect são geridos ao nível do projeto (App Users).",
            "openProjectQr": "Abrir códigos QR do projeto",
            "openFormAccess": "Gerir acesso a formulários",
            "notifications": {
              "assigned": "Código QR atribuído ao formulário",
              "unassigned": "Código QR desvinculado do formulário",
              "copied": "Base64 copiado para a área de transferência",
              "copyError": "Erro ao copiar: {error}"
            }
          },
          "attachments": {
            "title": "Anexos e Arquivos de Mídia",
            "description": "Gerir arquivos e anexos associados ao formulário",
            "xlsformFile": "Arquivo XLSForm",
            "xlsformDescription": "Baixar o arquivo XLSForm original deste formulário no formato Excel",
            "downloadXlsform": "Baixar XLSForm",
            "manageAttachments": "Gerir Anexos",
            "downloadSuccess": "Arquivo XLSForm baixado com sucesso",
            "downloadError": "Erro ao baixar arquivo XLSForm",
            "fileNotFound": "Arquivo XLSForm não encontrado para este formulário",
            "accessDenied": "Sem acesso para baixar arquivo XLSForm",
            "serverError": "Erro do servidor: {status}"
          },
          "analytics": {
            "title": "Gestão de análise",
            "recreateAnalytics": "Forçar recriação da análise",
            "description": "Recriar dados de análise para todas as submissões. Use quando os dados estiverem corrompidos ou em falta.",
            "warning": "Esta operação irá eliminar todas as análises existentes e recriá-las a partir dos dados brutos das submissões.",
            "confirmTitle": "Confirmar recriação da análise",
            "alertTitle": "Aviso: recriação de dados necessária",
            "alertDescription": "Esta ação irá eliminar permanentemente todos os dados de análise existentes e recriá-los de raiz.",
            "whatWillHappen": "O que irá acontecer:",
            "step1": "Todos os dados de análise existentes serão eliminados",
            "step2": "Os dados brutos das submissões serão reprocessados",
            "step3": "Novos dados de análise serão criados com formatação correta",
            "step4": "As tabelas dinâmicas e as funcionalidades de análise funcionarão corretamente",
            "timeWarning": "Esta operação pode demorar vários minutos em formulários com muitas submissões.",
            "recreateButton": "Forçar recriação da análise",
            "confirmButton": "Sim, recriar análise",
            "success": "Análise recriada com sucesso! {processed} submissões processadas, {recreated} registos de análise recriados de {total} submissões no total.",
            "error": "Falha ao recriar os dados de análise",
            "apiError": "Erro da API: {error}"
          },
          "dangerZone": {
            "title": "Zona de Perigo",
            "deleteForm": "Excluir Formulário",
            "description": "Esta ação não pode ser desfeita. Todos os dados coletados serão perdidos.",
            "confirmDelete": "Confirmar Exclusão do Formulário",
            "confirmMessage": "Tem certeza de que deseja excluir o formulário \"{name}\"?",
            "confirmDescription": "Esta ação não pode ser desfeita. Todos os dados coletados serão perdidos.",
            "enterFormName": "Digite o nome do formulário para confirmar",
            "deleteFormButton": "Excluir Formulário",
            "formDeleted": "Formulário excluído (função stub)"
          }
        },
        "datasets": {
          "title": "Conjuntos de Dados",
          "description": "Gerenciamento de conjuntos de dados e entidades"
        }
      },
      "errors": {
        "missingParams": "Parâmetros obrigatórios ausentes para carregar o formulário",
        "loadError": "Erro ao carregar dados do formulário",
        "unknownError": "Erro desconhecido"
      }
    },
    "dashboard": {
      "loading": "Carregando análises...",
      "analyticsError": "Erro ao carregar análises",
      "retry": "Tentar novamente",
      "workbench": {
        "contextHint": "Identidade do formulário, coleta, linha do tempo e AI para um período compartilhado (7 / 30 / all).",
        "completionBadge": "{rate}% de conclusão",
        "metaVersion": "v{version}",
        "metaPublished": "pub. {date}",
        "metaUpdated": "atual. {date}",
        "summaryTitle": "Resumo da coleta",
        "sections": {
          "metadata": {
            "title": "Identidade do formulário",
            "xmlFormId": "ID XML do formulário",
            "version": "Versão",
            "published": "Publicado",
            "updated": "Última atualização"
          },
          "intake": {
            "title": "Resumo da coleta",
            "subtitle": "Submissões de hoje, desta semana e no total"
          },
          "quickLinks": {
            "title": "Links rápidos"
          },
          "agent": {
            "title": "Assistente IA",
            "subtitle": "Resumos, relatórios analíticos ou chat sobre este formulário"
          },
          "timeline": {
            "title": "Linha do tempo de submissões",
            "subtitle": "Volume diário no período selecionado"
          },
          "map": {
            "title": "Distribuição geográfica",
            "subtitle": "Locais de submissão com dados geo"
          }
        },
        "metrics": {
          "noChange": "Sem alterações"
        },
        "intakeStrip": {
          "ariaLabel": "Status de coleta de dados",
          "today": "Hoje",
          "todayDelta": "{delta} vs ontem",
          "todayFlat": "Igual a ontem",
          "week": "Esta semana",
          "weekDelta": "{delta} vs semana passada",
          "weekFlat": "Igual à semana passada",
          "total": "Todas as respostas",
          "totalHint": "Total coletado para este formulário",
          "totalEmpty": "Ainda sem respostas"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Total de Submissões",
          "today": "hoje"
        },
        "completedSubmissions": {
          "title": "Submissões Concluídas",
          "rate": "taxa de conclusão"
        },
        "dataCollectors": {
          "title": "Coletores de Dados",
          "new": "novos"
        },
        "problematicSubmissions": {
          "title": "Submissões Problemáticas"
        },
        "submissionTimeline": {
          "title": "Linha do Tempo de Submissões",
          "totalForPeriod": "Total do período",
          "noData": "Sem dados da linha do tempo de submissões",
          "noSubmissionsInPeriod": "Sem submissões no período selecionado",
          "stats": {
            "totalSubmissions": "Total de submissões",
            "maxPerDay": "Máximo por dia",
            "trend": "Tendência"
          },
          "timeframes": {
            "7days": "Últimos 7 dias",
            "30days": "Últimos 30 dias",
            "90days": "Últimos 90 dias"
          },
          "trend": {
            "stable": "Sem mudanças",
            "growth": "Crescimento",
            "decline": "Declínio"
          },
          "hint": "Clique em uma barra para ver informações detalhadas do dia"
        }
      }
    },
    "summaryCard": {
      "id": "ID",
      "statusNotSet": "Status não definido",
      "statusDescriptions": {
        "published": "O formulário está aberto para coleta de dados",
        "closing": "O formulário está fechando, novas respostas são limitadas",
        "closed": "O formulário está fechado, novas respostas não são aceitas",
        "draft": "O formulário está em modo rascunho, não publicado",
        "unknown": "Status não reconhecido"
      },
      "stats": {
        "today": "Hoje",
        "week": "Esta semana",
        "total": "Total coletado",
        "responses": "respostas do formulário",
        "fromYesterday": "desde ontem",
        "fromLastWeek": "desde a semana passada"
      },
      "info": {
        "version": "Versão",
        "notSpecified": "Não especificado",
        "created": "Criado",
        "updated": "Atualizado",
        "notUpdated": "Não atualizado",
        "published": "Publicado",
        "notPublished": "Não publicado",
        "notSpecifiedDate": "Não especificado"
      },
      "trend": {
        "title": "Tendência de preenchimento nos últimos 7 dias",
        "noData": "Sem dados",
        "growth": "Crescimento",
        "decline": "Declínio",
        "stable": "Sem mudanças"
      }
    },
    "attachments": {
      "title": "Anexos do formulário",
      "formLabel": "Formulário:",
      "noAttachmentsRequired": "Nenhum anexo necessário",
      "noAttachmentsDescription": "Este formulário não contém referências a arquivos externos (imagens, documentos, etc.).",
      "noAttachmentsHint": "Se você adicionar referências de arquivos no XLSForm, elas aparecerão automaticamente aqui.",
      "uploadSection": {
        "supportedFormats": "Formatos suportados:",
        "dropZoneTitles": {
          "uploadMissing": "Carregar arquivos ausentes",
          "updateExisting": "Atualizar arquivos existentes",
          "uploadFiles": "Carregar arquivos"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Esperado {count} arquivo(s): {files}",
          "updateExisting": "Todos os arquivos foram carregados. Você pode substituí-los por novas versões.",
          "uploadFiles": "Selecione arquivos para carregar anexos do formulário."
        },
        "dropZoneButtons": {
          "selectFiles": "Selecionar arquivos",
          "updateFiles": "Atualizar arquivos",
          "chooseFiles": "Escolher arquivos"
        },
        "selectedFiles": "Arquivos selecionados ({count})",
        "uploadButton": "Carregar {count} arquivos",
        "uploading": "Carregando...",
        "clear": "Limpar",
        "chooseFiles": "Escolher arquivos"
      },
      "table": {
        "columns": {
          "name": "Nome do arquivo",
          "status": "Estado",
          "type": "Tipo",
          "size": "Tamanho",
          "updatedAt": "Data de carregamento",
          "actions": "Ações"
        },
        "status": {
          "uploaded": "Carregado",
          "missing": "Ausente",
          "deleted": "Excluído",
          "unknown": "Desconhecido"
        },
        "actions": {
          "download": "Baixar",
          "delete": "Excluir",
          "deleted": "Excluído",
          "missing": "Ausente"
        },
        "notSpecified": "Não especificado"
      },
      "messages": {
        "uploadSuccess": "Carregados com sucesso {count} arquivos",
        "uploadError": "Erro ao carregar arquivos: {error}",
        "fileNotFound": "Arquivo {filename} não encontrado nos arquivos selecionados",
        "fileUploadSuccess": "Arquivo {filename} carregado com sucesso",
        "fileUploadError": "Erro ao carregar arquivo {filename}: {error}",
        "downloadError": "Erro ao baixar arquivo {filename}: {error}",
        "deleteSuccess": "Arquivo {filename} excluído com sucesso",
        "deleteError": "Erro ao excluir arquivo {filename}: {error}",
        "invalidFilesIgnored": "Os seguintes arquivos serão ignorados (não encontrados na lista esperada): {files}",
        "filesWillBeUpdated": "Os seguintes arquivos serão atualizados: {files}",
        "loadingError": "Erro ao carregar anexos",
        "downloadSuccess": "Arquivo {filename} baixado com sucesso",
        "fileAlreadyDeleted": "O arquivo {filename} já foi excluído ou não existe",
        "fileNotInExpectedList": "Arquivo não encontrado na lista de anexos esperados"
      },
      "confirmDelete": {
        "title": "Confirmar exclusão",
        "message": "Tem certeza de que deseja excluir o arquivo \"{filename}\"?",
        "warning": "Esta ação não pode ser desfeita.",
        "deleting": "Excluindo...",
        "delete": "Excluir"
      }
    }
  },
  "pageNotFound": {
    "title": "Opa! Página não encontrada.",
    "subtitle": "404",
    "description": "A página que você procura não existe ou foi movida.",
    "goBack": "Voltar",
    "goHome": "Ir para a página inicial",
    "copyright": "© {year} UDACAPI. Todos os direitos reservados."
  },
  "maps": {
    "tabTitle": "Mapa",
    "pageTitle": "Mapa do projeto",
    "subtitle": "Acompanhe em tempo real as submissões com GPS",
    "empty": {
      "noGeoForms": "Nenhum formulário deste projeto tem perguntas de GPS ainda.",
      "noPoints": "Nenhuma submissão corresponde aos filtros atuais."
    },
    "filters": {
      "title": "Filtros",
      "forms": "Formulários",
      "dateFrom": "De",
      "dateTo": "Até",
      "qcStatus": "Status QC",
      "enumerator": "Enumerador",
      "heatmap": "Mapa de calor",
      "reset": "Redefinir filtros",
      "apply": "Aplicar"
    },
    "qcStatuses": {
      "any": "Qualquer",
      "pass": "Aprovado",
      "fail": "Reprovado",
      "warning": "Aviso",
      "error": "Erro",
      "none": "Não validado"
    },
    "actions": {
      "export": "Exportar GeoJSON",
      "refresh": "Atualizar",
      "settings": "Configurações do mapa",
      "openSubmission": "Abrir submissão",
      "openFormOnMap": "Ver formulário no mapa"
    },
    "popup": {
      "submittedAt": "Enviado em",
      "submittedBy": "Enviado por",
      "form": "Formulário",
      "status": "Status QC"
    },
    "truncated": "A mostrar os primeiros {limit} pontos. Ajuste os filtros ou ative o agrupamento para ver mais.",
    "settingsDialog": {
      "title": "Configurações do mapa do projeto",
      "defaultCenter": "Centro padrão",
      "defaultCenterHint": "Clique no mapa para escolher um local",
      "defaultZoom": "Zoom padrão",
      "defaultForms": "Formulários padrão",
      "heatmapDefault": "Mostrar mapa de calor por padrão",
      "coordinateFields": "Campos de coordenadas",
      "latitudeField": "Campo de latitude",
      "longitudeField": "Campo de longitude",
      "automaticDetection": "Usar detecção automática",
      "coordinateSourceTitle": "Fonte de coordenadas",
      "coordinateMode": "Modo de coordenadas",
      "modeAuto": "Detecção automática",
      "modeNone": "Sem dados de localização",
      "modeLatLon": "Campos de latitude e longitude",
      "modeGeopoint": "Campo geopoint",
      "geopointField": "Campo geopoint",
      "detectedSource": "Fonte detetada: {path} · pontos atuais: {count}",
      "configureCoordinates": "Campos de coordenadas",
      "noMapHint": "Sem pontos no mapa para este formulário. Configure os campos de coordenadas se as submissões tiverem localizações.",
      "save": "Salvar",
      "cancel": "Cancelar",
      "saved": "Configurações salvas"
    },
    "savedViews": {
      "title": "Visualizações salvas",
      "noViewsYet": "Sem visualizações salvas — crie no mapa do projeto",
      "recommended": "Recomendado",
      "defaultLabel": "predefinição",
      "saveHint": "Depois de Aplicar, o mapa usa os filtros e o mapa de calor. «Salvar visualização atual» guarda esta configuração com um nome (apenas gestores do projeto).",
      "saveCurrent": "Salvar visualização atual",
      "updateCurrent": "Atualizar visualização",
      "delete": "Excluir visualização",
      "name": "Nome da visualização",
      "pinAsDefault": "Fixar como padrão",
      "pin": "Fixar visualização",
      "saved": "Visualização salva",
      "updated": "Visualização atualizada",
      "deleted": "Visualização excluída",
      "saveFailed": "A visualização não pôde ser salva. Verifique se a API está implantada e se as migrações da base de dados incluem project_map_views.",
      "updateFailed": "A visualização não pôde ser atualizada.",
      "deleteFailed": "A visualização não pôde ser excluída."
    },
    "tileConfig": {
      "sectionTitle": "Servidor de tiles do mapa",
      "sectionDescription": "Relatório um URL de servidor de tiles personalizado para sua organização. Deixe em branco para usar os tiles públicos do OpenStreetMap.",
      "url": "Modelo de URL dos tiles",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Atribuição",
      "subdomains": "Subdomínios",
      "maxZoom": "Zoom máx.",
      "minZoom": "Zoom mín.",
      "test": "Testar URL",
      "configure": "Configurar",
      "edit": "Editar",
      "defaultTiles": "Usando tiles públicos do OpenStreetMap",
      "zoom": "Zoom",
      "clear": "Limpar",
      "save": "Salvar",
      "saved": "Configuração de tiles salva",
      "cleared": "Servidor de tiles personalizado removido"
    }
  },
  "help": {
    "title": "Ajuda",
    "subtitle": "Guias curtos e respostas para tarefas comuns do UDACAPI.",
    "searchPlaceholder": "Buscar guias e perguntas…",
    "learnMore": "Saiba mais",
    "openGuide": "Abrir",
    "openGuideFormScope": "Abrir o painel — depois escolha um projeto e um formulário",
    "whenToUse": "Quando usar",
    "steps": "Passos",
    "comingSoon": "Mais guias sobre análise, monitoramento e configurações da organização em breve.",
    "noResults": "Nenhum guia corresponde à sua busca.",
    "featureGuides": {
      "odkServers": {
        "title": "Servidores ODK",
        "summary": "Conecte seu servidor ODK Central (ou compatível) para que o UDACAPI possa sincronizar projetos e submissões.",
        "whenToUse": "Configuração inicial, antes de sincronizar ou importar.",
        "steps": [
          "Abra Servidores ODK na barra lateral.",
          "Adicione a URL do servidor e as credenciais.",
          "Execute Testar conexão.",
          "Corrija URL, credenciais ou problemas de rede antes de sincronizar."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Obtenha novas submissões e atualize a estrutura do formulário a partir do ODK.",
        "whenToUse": "Após conectar o servidor; quando você espera novos dados de campo.",
        "steps": [
          "Abra o Sync Workbench.",
          "Selecione servidor, projeto e formulário.",
          "Revise o cursor e o status da última sincronização.",
          "Inicie a sincronização e aguarde a conclusão.",
          "Abra o formulário — Overview, Export ou QC."
        ]
      },
      "import": {
        "title": "Importar projetos e formulários",
        "summary": "Traga projetos e formulários ODK existentes para sua organização.",
        "whenToUse": "Migração do ODK ou integração de um novo servidor.",
        "steps": [
          "Certifique-se de que o servidor ODK está conectado e testado.",
          "Em Projetos, inicie Importar (apenas servidores da organização).",
          "Selecione um projeto e importe formulários.",
          "Abra um formulário e verifique Overview e Settings."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "Workbench de AI para rascunhar, visualizar e publicar alterações em XLSForm.",
        "whenToUse": "Novas pesquisas ou mudanças significativas no esquema.",
        "steps": [
          "Abra um projeto e inicie o XLSForm Assist.",
          "Descreva a pesquisa ou envie um arquivo de perguntas.",
          "Revise a visualização do ODK Web Forms.",
          "Confirme a publicação e aguarde a conclusão do job."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Instantâneo de coleta, linha do tempo, mapa e perguntas e respostas com AI para o período selecionado.",
        "whenToUse": "Monitoramento diário; perguntas rápidas sobre dados ao vivo do formulário.",
        "steps": [
          "Abra um formulário e vá para Overview.",
          "Escolha o período (7 / 30 / all) — compartilhado por relatórios AI e linha do tempo.",
          "Revise a linha do tempo e o mapa.",
          "Use o chat AI ou gere relatórios resumidos para a mesma janela."
        ]
      },
      "autoReports": {
        "title": "Relatórios automáticos",
        "summary": "Relatórios AI agendados e sob demanda por formulário com entrega por email.",
        "whenToUse": "Atualizações regulares para stakeholders (semanal ou mensal).",
        "steps": [
          "Org → Modelos de relatório — crie ou escolha um modelo.",
          "Formulário → Relatórios automáticos — defina agendamento e destinatários.",
          "Use Generate para uma visualização manual com período.",
          "Use Send para entregar após a visualização."
        ]
      },
      "qc": {
        "title": "Controle de qualidade (QC)",
        "summary": "Regras de validação em submissões; a AI pode sugerir um pacote inicial.",
        "whenToUse": "Após as primeiras submissões; antes de confiar em exportações ou análises.",
        "steps": [
          "Abra um formulário e vá para QC.",
          "Crie uma regra ou use sugestão AI.",
          "Execute a validação.",
          "Revise as submissões sinalizadas."
        ]
      },
      "export": {
        "title": "Exportação de dados",
        "summary": "Exporte submissões para CSV, Excel e mais; formulários grandes usam jobs assíncronos.",
        "whenToUse": "Entrega para Excel, SPSS, Stata ou pipelines externos.",
        "steps": [
          "Abra um formulário e vá para Data Export.",
          "Escolha formato e opções.",
          "Inicie a exportação e aguarde o job.",
          "Baixe o arquivo da lista de jobs."
        ]
      }
    },
    "faq": {
      "title": "Perguntas frequentes",
      "items": {
        "sync-no-new-data": {
          "question": "Por que a sincronização não está obtendo novas submissões?",
          "answer": "Verifique se o servidor ODK está acessível, se o cursor de sync não está preso em uma posição antiga, se você selecionou o formulário correto e se sua conta tem acesso a esse projeto. Execute Testar conexão no servidor e tente sincronizar novamente pelo Sync Workbench."
        },
        "sync-cursor": {
          "question": "O que é um cursor de sincronização?",
          "answer": "Um cursor é o ponteiro de sincronização incremental — onde o UDACAPI parou de ler submissões pela última vez. Resetar ou desalinhar cursores pode pular ou buscar dados novamente; use o Sync Workbench para inspecionar o status do cursor antes de forçar uma ressincronização completa."
        },
        "import-server-type": {
          "question": "Por que não posso importar deste servidor?",
          "answer": "A importação de projetos é permitida apenas em servidores ODK da organização. Servidores Shared e Global não podem ser usados para importação — conecte um servidor da org ou fale com seu administrador."
        },
        "import-how": {
          "question": "Como importo um projeto ODK existente?",
          "answer": "Conecte e teste o servidor, depois vá em Projetos → Importar, escolha o projeto e importe formulários. Veja o guia Importar projetos e formulários acima para instruções passo a passo."
        },
        "xlsform-where": {
          "question": "Onde fica o XLSForm Assist?",
          "answer": "Abra um projeto em Projetos, depois inicie o XLSForm Assist na área de formulários do projeto (ou na rota dedicada de assistência desse projeto)."
        },
        "ai-scope": {
          "question": "O que a AI do formulário pode responder?",
          "answer": "Perguntas sobre o esquema do formulário, submissões, análises, regras QC e status de sync — com base em dados ao vivo desse formulário. Não substitui aprovação QC nem revisão legal de dados pessoais."
        },
        "ai-quota": {
          "question": "Por que vejo cota excedida?",
          "answer": "Sua organização atingiu um limite de uso do agente. Aguarde a janela de reset ou fale com o proprietário ou administrador da organização para ajustar os limites."
        },
        "auto-generate-vs-schedule": {
          "question": "Qual é a diferença entre Generate e um relatório agendado?",
          "answer": "Generate roda sob demanda para o período que você escolhe no formulário. Execuções agendadas seguem o cron do modelo e usam a janela de dados alinhada ao agendamento — não necessariamente a mesma do seletor de período do Overview."
        },
        "auto-templates": {
          "question": "Onde os modelos de relatório são gerenciados?",
          "answer": "No nível da organização: Minha organização → Modelos de relatório (ou o link rápido de modelos). Os modelos são centrais da org; a aba Relatórios automáticos de cada formulário mostra modelos que cobrem esse formulário."
        },
        "qc-first-rule": {
          "question": "Como crio minha primeira regra QC?",
          "answer": "Abra o formulário → QC → Criar regra, ou use sugestão AI para rascunhar um pacote inicial a partir da estrutura do formulário, depois execute a validação."
        },
        "export-slow": {
          "question": "A exportação está demorando — isso é normal?",
          "answer": "Sim, para formulários grandes. Exportações rodam como jobs em segundo plano. Mantenha a página aberta ou volte ao Data Export para baixar quando o job concluir."
        },
        "export-where": {
          "question": "Onde está meu arquivo exportado?",
          "answer": "Na aba Data Export do formulário — na lista de jobs/histórico com ação de download quando o status do job for complete."
        },
        "permissions-missing": {
          "question": "Não vejo um projeto ou aba",
          "answer": "Seu grupo de permissões pode não incluir esse projeto ou recurso. Peça ao proprietário da organização para revisar grupos de permissões e acesso a projetos."
        }
      }
    },
    "support": {
      "title": "Precisa de mais ajuda?",
      "body": "Entre em contato com o suporte UDACAPI se estes guias não resolverem seu problema.",
      "contactLabel": "Enviar email ao suporte"
    }
  }
}
